(() => {
  'use strict';

  /* =========================================================
     RÉGLAGES : tout ce qui est modifiable facilement est ici
     ========================================================= */
  // Prix par devise : assets/js/prix.js · Textes dans la langue de la page : assets/js/i18n/<langue>.js
  const L = window.KP_I18N;
  const kzFixe = document.createElement('div');
  kzFixe.className = 'kz kz-fixe'; kzFixe.dataset.page = 'produit';
  document.body.appendChild(kzFixe);
  document.querySelectorAll('.kz #cart, .kz #checkout, .kz #toast, .kz dialog').forEach(el => kzFixe.appendChild(el));
  // Photos de la galerie : la 1re tout de suite, les suivantes chargées en arrière-plan dès que la page est prête
  // (sinon chacune n'arrive qu'au moment où l'on fait défiler)
  const prechargerGalerie = () => document.querySelectorAll('.kz .minis__item img[loading="lazy"]').forEach(i => { i.loading = 'eager'; });
  const premiere = document.querySelector('.kz .minis__item--vie img');
  if (!premiere || premiere.complete) setTimeout(prechargerGalerie, 300);
  else { premiere.addEventListener('load', () => setTimeout(prechargerGalerie, 150), { once: true }); setTimeout(prechargerGalerie, 2500); }
  const GRILLES = window.KP_PRIX;
  // T-shirts tout faits des gammes japonaises (assets/js/catalogue.js) : vendus avec les personnalisés, même panier
  const CATALOGUE = (c => { const gammes = c.gammes.filter(g => !g.cache); return { gammes, modeles: c.modeles.filter(m => gammes.some(g => g.id === m.g)) }; })(window.KP_CATALOGUE || { gammes: [], modeles: [] });
  const modeleParId = id => CATALOGUE.modeles.find(m => m.id === id);
  const gammeParId = id => CATALOGUE.gammes.find(g => g.id === id);
  const nomModele = m => (m.tr && m.tr[L.lang]) || m.nom;
  // Page en cours : « accueil » (vitrine), « produit » (t-shirt personnalisé), « boutique » ou « modele » (t-shirt tout fait).
  // Sur l'accueil et les pages de la boutique, le formulaire du t-shirt personnalisé est présent mais caché (scripts/build.js).
  const PAGE = 'produit'; // boutique Shopify : seule la page du t-shirt personnalisé
  const PAGE_BOUTIQUE = PAGE === 'boutique' || PAGE === 'modele' || PAGE === 'accueil';
  const RACINE = L.lang === 'fr' ? '/' : `/${L.lang}/`; // adresses absolues : les modèles sont dans /t-shirt/…
  const CONFIG = {
    noteMoyenne: 4.74,                  // note moyenne réelle des avis « Votre animal en samouraï » (assets/data/avis.json, recalculée au chargement)
    nombreAvis: 547,                   // nombre réel d'avis (idem)
    joursLivraison: [3, 6],             // jours ouvrés entre l'aperçu et la livraison (min, max) — l'aperçu, lui, arrive toujours en 24h, week-end compris
    joursEstimes: [3, 4],               // fourchette courte des frises (fiche produit, panier, paiement) : réception la plus probable ; les textes (FAQ, CGV) gardent 3 à 6
    // Clé PUBLIQUE Stripe (faite pour être visible). Mode test : pk_test_… ; au lancement : pk_live_…
    // Clé publique Stripe (mode réel). Doit appartenir au même compte que STRIPE_SECRET_KEY (réglages Netlify).
    stripe: 'pk_live_51UMuVZD4Uogy7kUDgaxmDkwyKGZ7dvcBLwVTIbG2b893E371Og9OT6MMG7uFDtAN72OFJjDQuN10snUe8FRa8xWD00B71eDPi5'
  };

  if (window.KZ && window.KZ.nombreAvis) { CONFIG.noteMoyenne = window.KZ.noteMoyenne; CONFIG.nombreAvis = window.KZ.nombreAvis; }

  // Avis clients : les vrais avis sont dans assets/data/avis.json
  // (format : { moyenne, total, repartition: [5★, 4★, 3★, 2★, 1★], avis: [{ n, r, ti, t, d, c, v, p: [photos] }] }).

  // Couleurs de kimono (noms dans la langue de la page : L.colors)
  const COLORS = [
    { id: 'vermillon', hex: '#C8442C', img: 4, name: '#C0574A', ex: 'Minouche' },
    { id: 'bordeaux',  hex: '#8E2B47', img: 1, name: '#A3415F', ex: 'Figgy' },
    { id: 'yuzu',      hex: '#E0B53A', img: 2, name: '#D1A93A', ex: 'Yuzu' },
    { id: 'vert',      hex: '#5E7D4A', img: 9, src: 'perso-8', name: '#5E7D4A', ex: 'Nina' }, // visuel : t-shirt de Nina le beagle
    { id: 'turquoise', hex: '#2F8C8A', img: 3, name: '#2F8790', ex: 'Roxy' },
    { id: 'lavande',   hex: '#9583B5', img: 5, name: '#8E7BB0', ex: 'Naya' },
    { id: 'sakura',    hex: '#E3A0AC', img: 6, name: '#D17F8E', ex: 'Tamara' },
    { id: 'encre',     hex: '#2B2A2A', img: 7, name: '#3F3E3A', ex: L.lang === 'fr' ? 'Bounty' : 'Jasper', retire: true }, // retirée de la vente (21/10/2026) : gardée pour les paniers déjà enregistrés ; // nouveau visuel ninja en français seulement (produit-7.webp)
    { id: 'indigo',    hex: '#34507C', img: 8, name: '#4A6A8E', ex: 'Willow' },
    { id: 'surprise',  hex: null,      img: null, name: null, ex: null } // plus proposée (15/10/2026) : gardée pour les paniers déjà enregistrés
  ].map(c => ({ ...c, label: L.colors[c.id] }));
  // PORTRAIT KIMONO (page « kimono », 27/10/2026) : un seul animal, kimono bleu imposé (pas de choix), visuels du portrait
  const PORTRAIT = !!(window.KZ && window.KZ.style === 'portrait');
  if (PORTRAIT) COLORS.push({ id: 'portrait', hex: '#34507C', img: 1, ex: 'Figgy', label: 'Bleu' });
  // Exemple de t-shirt dans une couleur de kimono, annoté « + Son prénom en japonais » dans la langue de la page
  const visuelCouleur = n => {
    if (PORTRAIT) return window.KZ.portraitImgs[(n - 1) % window.KZ.portraitImgs.length];
    const c = COLORS.find(x => x.img === n);
    return `https://kizunapaws.com/assets/img/${(c && c.src) || `produit-${n}`}${L.lang === 'fr' ? '' : `-${L.lang}`}.webp`;
  };
  // Image qui ne charge pas (photo importée, vignette, photo d'avis) : un seul écouteur pour toute la page,
  // au lieu d'attributs onerror (interdits par les règles de sécurité CSP)
  document.addEventListener('error', e => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement) || !img.dataset.broken) return;
    if (img.dataset.broken === 'thumb') img.parentNode.classList.add('is-broken');
    else if (img.dataset.broken === 'rv') { const box = img.closest('.rv__photo'); if (box) box.remove(); }
    else img.style.display = 'none';
  }, true);

  const SIZES =['S', 'M', 'L', 'XL', 'XXL'];
  const MAX_PHOTOS = 3;
  const MAX_NAME = 16;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ===== Pays du visiteur et devise =====
     Le pays (et donc la devise) vient, dans l'ordre : du choix fait dans le sélecteur « Langue et pays »,
     du pays détecté lors d'une visite précédente (lu par early.js), sinon d'une détection à l'arrivée (/geo.json,
     d'après l'adresse IP, par Netlify). En attendant, les prix restent masqués (classe « devise-attente »). */
  // Royaume-Uni suspendu (TVA britannique obligatoire dès la 1re vente) : pour le rouvrir, remettre GB: 'GBP' ici,
  // 'GB' dans PAYS_LIVRES et remplirPays() ci-dessous, dans netlify/lib/pays.mjs et dans scripts/build.js (PAYS).
  const DEVISE_DU_PAYS = { US: 'USD', CA: 'CAD', AU: 'AUD', CH: 'CHF', LI: 'CHF' };
  // Pays livrés (même liste que netlify/lib/pays.mjs, vérifiée par le serveur)
  const PAYS_UE = ['FR', 'DE', 'AT', 'BE', 'BG', 'CY', 'HR', 'DK', 'ES', 'EE', 'FI', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'CZ', 'RO', 'SK', 'SI', 'SE'];
  const PAYS_LIVRES = [...PAYS_UE, 'CH', 'US', 'CA', 'AU'];
  const PAYS_PAR_LANGUE = { fr: 'FR', de: 'DE', it: 'IT', es: 'ES', en: 'US' };
  const lireStock = k => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const ecrireStock = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* navigation privée : sans conséquence */ } };
  let PAYS = window.KP_PAYS || '';
  let DEVISE = DEVISE_DU_PAYS[PAYS] || 'EUR';
  let G = GRILLES[DEVISE];

  /* ===== Mesure des publicités (pixel Meta) : seulement avec l'accord du visiteur =====
     Déclaré ici, en haut : le retour d'un paiement validé chez PayPal ou la banque envoie l'achat dès le chargement.
     Le bandeau de choix et le lien « Gérer les cookies » sont plus bas (partie « COOKIES »). */
  // Pixel de Nos Petites Pattes (même identifiant dans netlify/lib/meta.mjs) : il a l'historique d'achats de ce même
  // produit. Le pixel Kizuna Paws (1094719246876147) n'est plus utilisé depuis le 15/10/2026, au choix du propriétaire.
  const PIXEL_IDS = ['896483345184230'];
  const DUREE_CONSENT = 182 * 24 * 3600 * 1000; // choix gardé 6 mois, puis redemandé
  const lireConsent = () => {
    try { const c = JSON.parse(lireStock('kp-consent') || 'null'); return c && Date.now() - c.t < DUREE_CONSENT ? c.v : null; }
    catch (e) { return null; }
  };
  let consent = lireConsent(); // 'oui', 'non', ou null (pas encore choisi)
  let pixelCharge = false, vuProduit = false, vueEnvoyee = false, cookiesPrets = false;
  // Pays où la loi n'impose pas l'accord préalable (pas de bandeau) : la mesure y est active d'office, et le visiteur
  // peut la refuser avec « Gérer les cookies ». Partout ailleurs (France, UE, Canada/Québec, pays inconnu) : bandeau.
  const PAYS_SANS_BANDEAU = ['US', 'AU', 'CH', 'LI'];
  // TEMPORAIRE (19/10, test du propriétaire) : bandeau retiré partout, mesure active d'office comme aux États-Unis.
  // Pour remettre le bandeau : repasser BANDEAU_RETIRE à false (et redéployer).
  const BANDEAU_RETIRE = true;
  const sansBandeau = () => BANDEAU_RETIRE || PAYS_SANS_BANDEAU.includes(PAYS);
  const mesureAutorisee = () => consent === 'oui' || (consent === null && sansBandeau());
  function chargerPixel() {
    return; // Shopify charge le pixel (canal Meta)
    if (pixelCharge) { window.fbq('consent', 'grant'); return; }
    pixelCharge = true;
    // Code de base du pixel Meta, sans script en ligne (la politique de sécurité du site ne l'autorise pas)
    const f = window.fbq = function () { f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments); };
    if (!window._fbq) window._fbq = f;
    f.push = f; f.loaded = true; f.version = '2.0'; f.queue = [];
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(s);
    PIXEL_IDS.forEach(id => window.fbq('init', id));
    window.fbq('track', 'PageView');
    if (vuProduit) envoyerVueProduit();
  }
  // Événement Meta (ignoré sans accord). id : identifiant commun avec l'envoi du serveur (anti-doublon)
  function suivre(nom, params, id) {
    return;
    if (!mesureAutorisee()) return;
    if (!pixelCharge) chargerPixel();
    window.fbq('track', nom, params || {}, id ? { eventID: id } : undefined);
  }
  const produitMeta = (n, ref) => ({ content_type: 'product', content_ids: [ref || 'tshirt-samourai'],
    content_name: ref ? `T-shirt ${(modeleParId(ref) || {}).nom || ref}` : 'T-shirt samouraï personnalisé', num_items: n });

  /* ===== Mesure d'audience du site (statistiques de l'Atelier) : anonyme, sans cookie, sans accord nécessaire =====
     Exemption de la CNIL : seulement des compteurs pour le site (visites, étapes de la commande, sources), aucune donnée
     personnelle, aucun identifiant gardé d'une visite à l'autre. Chaque étape compte une fois par visite (onglet).
     Refus : lien « ?mesure=non » de la politique de confidentialité, ou réglage « Global Privacy Control » du navigateur. */
  const lireSession = k => { try { return sessionStorage.getItem(k); } catch (e) { return '1'; } };
  const ecrireSession = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* navigation privée stricte */ } };
  if (new URLSearchParams(location.search).get('mesure') === 'non') {
    ecrireStock('kp-mesure', 'non');
    history.replaceState(null, '', location.pathname + location.hash);
  }
  const mesureRefusee = () => lireStock('kp-mesure') === 'non' || navigator.globalPrivacyControl === true;
  function mesurer(etape) {
    return; // boutique Shopify : statistiques Shopify
    if (mesureRefusee() || lireSession('kp-m-' + etape)) return;
    ecrireSession('kp-m-' + etape, '1');
    const d = { e: etape, p: location.pathname, l: L.lang };
    if (etape === 'visite') {
      const q = new URLSearchParams(location.search);
      let r = '';
      try { if (document.referrer) { const u = new URL(document.referrer); if (u.hostname !== location.hostname) r = u.hostname; } } catch (e) { /* rien */ }
      const tactile = window.matchMedia('(pointer: coarse)').matches, cote = Math.min(screen.width, screen.height);
      Object.assign(d, { r, u: q.get('utm_source') || '', m: q.get('utm_medium') || '', c: q.get('utm_campaign') || '', f: q.has('fbclid') ? 1 : 0,
        d: tactile ? (cote < 600 ? 'mobile' : 'tablette') : 'ordinateur' });
    }
    const corps = JSON.stringify(d);
    try { if (navigator.sendBeacon && navigator.sendBeacon('/api/boutique/mesure', new Blob([corps], { type: 'application/json' }))) return; } catch (e) { /* repli ci-dessous */ }
    fetch('/api/boutique/mesure', { method: 'POST', body: corps, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
  }
  function envoyerVueProduit() {
    if (vueEnvoyee || !mesureAutorisee()) return;
    vueEnvoyee = true;
    suivre('ViewContent', { ...produitMeta(1), value: G.prixBase, currency: DEVISE });
  }

  // Montants : séparateurs et symbole selon la langue de la page et la devise (« 39,90 € », « $44.90 », « £33.90 »)
  function localeMonnaie() {
    if (DEVISE === 'CHF') return `${L.lang}-CH`;
    if (L.lang === 'en') return { USD: 'en-US', GBP: 'en-GB', CAD: 'en-CA', AUD: 'en-AU', EUR: 'en-IE' }[DEVISE] || 'en-US';
    if (L.lang === 'fr' && DEVISE === 'CAD') return 'fr-CA';
    return L.locale;
  }
  // Dates : format de la langue ; en anglais, celui du pays (« Oct 9 » aux États-Unis, « 9 Oct » au Royaume-Uni)
  const localeDates = () => (L.lang === 'en' ? ({ US: 'en-US', CA: 'en-CA', AU: 'en-AU', IE: 'en-IE' }[PAYS] || 'en-GB') : L.locale);
  const money = n => new Intl.NumberFormat(localeMonnaie(), { style: 'currency', currency: DEVISE }).format(n);
  // Montant rond sans décimales (« 10 € », « $11 ») : remises et suppléments
  const euros = n => new Intl.NumberFormat(localeMonnaie(), { style: 'currency', currency: DEVISE, minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(n);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouch = window.matchMedia('(hover: none)').matches;
  const colorById = id => COLORS.find(c => c.id === id);
  const colorByImg = n => COLORS.find(c => c.img === n);
  const esc = s => String(s).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
  const smooth = () => (reduceMotion ? 'auto' : 'smooth');

  /* =========================================================
     ÉTAT : l'offre (1 à 3 t-shirts) et la personnalisation de chaque t-shirt
     ========================================================= */
  const newTee = () => ({
    count: 1,     // animaux sur ce t-shirt
    size: null,
    surprise: false, // « Non, garder la surprise » : pas d'aperçu par e-mail avant l'impression
    animals: [0, 1, 2].map(() => ({ name: '', color: PORTRAIT ? 'portrait' : null, photos: [] })),
    // Page portrait : portrait créé en direct (etat : vide → creation → pret, ou erreur)
    portrait: { etat: 'vide', essais: 0, url: '', erreur: '', ctrl: null }
  });
  const state = {
    qty: 1,
    tees: [newTee(), newTee(), newTee()],
    activeTee: 0,
    activeAnimal: 0,
    previewImg: PORTRAIT ? 1 : 4
  };
  const cart = [];


  // T-shirt samouraï créé en direct (31/10/2026) : même parcours que le portrait (un seul animal, aperçu sur le t-shirt du
  // cintre) ; le dessin vient du générateur samouraï (couleur du kimono), le prénom en japonais
  // de api/katakana.js, traduit pendant que le client tape
  const PORTRAIT_DIRECT = PORTRAIT;
  const SAMOURAI_DIRECT = !PORTRAIT;
  const DIRECT = PORTRAIT_DIRECT || SAMOURAI_DIRECT;
  document.documentElement.classList.toggle('pk-direct', DIRECT); // styles des pages en direct (frise, aperçu)
  const API_SAMOURAI = 'https://samourai-api-seven.vercel.app/api/generate';
  const API_KATAKANA = 'https://samourai-api-seven.vercel.app/api/katakana';
  const COULEUR_API = { vermillon: 'orange', bordeaux: 'bordeaux', yuzu: 'jaune', vert: 'vert', turquoise: 'turquoise', lavande: 'mauve', sakura: 'rose', encre: 'noir', indigo: 'bleu marine' };
  const couleurNom = id => (colorById(id) || {}).name || '#A3415F';
  // Jeton du jour du générateur
  const jetonGenerateur = () => Promise.resolve(window.KZ.jeton);
  // Design samouraï : boîte 900 × 1050 (prénom + japonais au-dessus du dessin, au plus 900 × 900), sur le t-shirt du cintre
  // au même endroit et à la même taille que sur les photos produit samouraï (56 % de la largeur, bas à 91 % ; t-shirt de 1100 px)
  const BOITE_SAMOURAI = [-44, 310, 616, 616 * 1050 / 900];
  // Prénom (46) et japonais (24) au-dessus du dessin, dans la couleur du kimono, comme sur le t-shirt imprimé ;
  // haut : première ligne du dessin qui n'est pas blanche (fraction de sa hauteur)
  function nomSamouraiSVG(nom, kana, couleur, dessin) {
    const n = nom.trim(), bas = (dessin ? 1050 - dessin.h : 150) - 16;
    if (!n) return '';
    return `<text x="450" y="${(kana ? bas - 36 : bas).toFixed(0)}" font-size="56" fill="${couleur}">${esc(n)}</text>`
      + (kana ? `<text x="450" y="${bas.toFixed(0)}" font-size="28" fill="${couleur}">${esc(kana)}</text>` : '');
  }
  // Fond du dessin généré rendu blanc pur : l'IA laisse un léger voile (« papier », 240 à 254 au lieu de 255) qui s'imprime
  // en carré gris sur le t-shirt (commande n°5920). Seuls les pixels clairs et neutres changent, avec un passage progressif ;
  // les couleurs restent intactes. Le niveau du fond est mesuré sur les bords de l'image.
  function blanchirFond(d, W, H) {
    const valeurs = [], b = Math.round(Math.min(W, H) * 0.02), pasX = Math.max(1, W >> 9), pasY = Math.max(1, H >> 9);
    const lire = (i, l) => { const k = (l * W + i) * 4, m = Math.min(d[k], d[k + 1], d[k + 2]); if (Math.max(d[k], d[k + 1], d[k + 2]) - m <= 16 && m >= 190 && m < 255) valeurs.push(m); };
    for (let i = 0; i < W; i += pasX) for (let l = 0; l < b; l++) { lire(i, l); lire(i, H - 1 - l); }
    for (let l = 0; l < H; l += pasY) for (let i = 0; i < b; i++) { lire(i, l); lire(W - 1 - i, l); }
    valeurs.sort((x, y) => x - y);
    const fond = valeurs.length >= 50 ? valeurs[valeurs.length >> 1] : 255, haut = Math.min(fond - 12, 238), bas = haut - 22;
    for (let k = 0; k < d.length; k += 4) {
      const m = Math.min(d[k], d[k + 1], d[k + 2]);
      if (m <= bas || Math.max(d[k], d[k + 1], d[k + 2]) - m > 22) continue;
      const t = m >= haut ? 1 : (m - bas) / (haut - bas);
      d[k] += (255 - d[k]) * t; d[k + 1] += (255 - d[k + 1]) * t; d[k + 2] += (255 - d[k + 2]) * t;
    }
  }
  // Dessin samouraï sans ses marges blanches, à sa taille dans la boîte (le plus grand possible dans 900 × 900)
  async function rognerDessin(blob) {
    const img = await decoderImage(blob);
    const w = img.width, h = img.height, c = document.createElement('canvas');
    c.width = w; c.height = h;
    const x = c.getContext('2d');
    x.drawImage(img, 0, 0);
    const donnees = x.getImageData(0, 0, w, h), d = donnees.data;
    blanchirFond(d, w, h);
    x.putImageData(donnees, 0, 0);
    let x0 = w, y0 = h, x1 = 0, y1 = 0;
    for (let y = 0; y < h; y += 2) for (let i = 0; i < w; i += 2) {
      const k = (y * w + i) * 4;
      if (Math.min(d[k], d[k + 1], d[k + 2]) < 235) { if (i < x0) x0 = i; if (i > x1) x1 = i; if (y < y0) y0 = y; if (y > y1) y1 = y; }
    }
    if (x1 <= x0 || y1 <= y0) { x0 = 0; y0 = 0; x1 = w - 1; y1 = h - 1; }
    const cw = x1 - x0 + 2, ch = y1 - y0 + 2, rc = document.createElement('canvas');
    rc.width = cw; rc.height = ch;
    rc.getContext('2d').drawImage(c, x0, y0, cw, ch, 0, 0, cw, ch);
    const e = Math.min(900 / cw, 900 / ch);
    return { blob: await new Promise(ok => rc.toBlob(ok, 'image/png')), l: cw * e, h: ch * e };
  }
  async function hautDessin(blob) {
    const img = await decoderImage(blob);
    const c = document.createElement('canvas');
    c.width = c.height = 200;
    const x = c.getContext('2d');
    x.drawImage(img, 0, 0, 200, 200);
    const d = x.getImageData(0, 0, 200, 200).data;
    for (let l = 0; l < 200; l++) for (let i = 0; i < 200; i++) { const k = (l * 200 + i) * 4; if (Math.min(d[k], d[k + 1], d[k + 2]) < 225) return l / 200; }
    return 0;
  }
  // Prénom en japonais : demandé une fois le prénom tapé (0,7 s après la dernière lettre), gardé pour ce prénom
  const kanaDe = p => nom => (p.kanaNom === nom.trim() ? p.kana : '');
  async function traduireKana(p, nom) {
    if (!nom || p.kanaNom === nom) return;
    try {
      const r = await fetch(API_KATAKANA, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: await jetonGenerateur(), name: nom }) });
      const d = await r.json();
      if (r.ok && typeof d.kana === 'string') { p.kana = d.kana; p.kanaNom = nom; }
    } catch (e) { /* sans japonais : seul le prénom est écrit */ }
  }
  const minuteursKana = {};
  function demanderKana(k) {
    clearTimeout(minuteursKana[k]);
    minuteursKana[k] = setTimeout(async () => {
      const t = state.tees[k], nom = t.animals[0].name.trim();
      await traduireKana(t.portrait, nom);
      if (t.animals[0].name.trim() === nom) { majPrenomPortrait(k, true); preparerPlusTard(k); }
    }, 700);
  }
  // Fichier imprimé du samouraï : 2048 × 2389 sur fond blanc, prénom + japonais au-dessus du dessin
  async function fichierSamourai(blob, nom, kana, couleur, dessin) {
    try { await document.fonts.load('700 72px "M PLUS Rounded 1c"', nom + kana); } catch (e) { /* police de secours */ }
    const img = await decoderImage(blob);
    const W = 2048, f = W / 900, H = Math.round(1050 * f), HAUT = Math.round(150 * f);
    const c = document.createElement('canvas');
    c.width = W; c.height = H;
    const x = c.getContext('2d');
    x.imageSmoothingQuality = 'high';
    x.fillStyle = '#fff';
    x.fillRect(0, 0, W, H);
    x.drawImage(img, (900 - dessin.l) / 2 * f, (1050 - dessin.h) * f, dessin.l * f, dessin.h * f);
    const bas = (1050 - dessin.h - 16) * f;
    x.textAlign = 'center';
    x.fillStyle = couleur;
    if (nom) {
      x.font = `700 ${56 * f}px "M PLUS Rounded 1c", "Manrope", sans-serif`;
      x.fillText(nom, W / 2, kana ? bas - 36 * f : bas);
      if (kana) { x.font = `700 ${28 * f}px "M PLUS Rounded 1c", sans-serif`; x.fillText(kana, W / 2, bas); }
    }
    return new Promise(ok => c.toBlob(ok, 'image/jpeg', 0.92));
  }
  // Fichier imprimé selon la page (portrait kimono ou samouraï)
  async function fichierDesign(t) {
    const p = t.portrait, nom = t.animals[0].name.trim();
    if (!SAMOURAI_DIRECT) return fichierPortrait(p.blob, nom);
    await traduireKana(p, nom);
    return fichierSamourai(p.blobDessin, nom, kanaDe(p)(nom), couleurNom(p.couleur), p.dessin);
  }

  /* ===== Portrait kimono créé en direct (page « kimono », 30/10/2026, comme sur kizunapaws.com) =====
     Dès que la photo est choisie, l'IA crée le portrait (samourai-api, api/portrait.js, ~20 s) pendant que le client écrit
     le prénom et choisit la taille. L'aperçu le montre sur le t-shirt du cintre, exactement comme les photos produit
     (même endroit, même taille), avec sa photo dans la bulle ; jamais le portrait seul. À l'ajout au panier, le portrait et
     le prénom sont assemblés (2000 px) et envoyés sur Cloudinary : c'est ce fichier qui est imprimé (« Portrait à imprimer »). */
  const API_PORTRAIT = 'https://samourai-api-seven.vercel.app/api/portrait';
  const MAX_PORTRAITS = 3;     // créations par t-shirt
  const DUREE_PORTRAIT = SAMOURAI_DIRECT ? 25 : 20;   // secondes environ, pour la barre de progression (samouraï : qualité medium)
  // Mesures relevées sur les photos produit (cintre, 1100 px) : design de 612 px posé à (-39, 351), bulle de la photo
  // centrée en (828.8, 262), flèche dessous
  const PK_TEE = (window.KZ && window.KZ.pkTee) || '', PK_FLECHE = (window.KZ && window.KZ.pkFleche) || '';
  // Prénom en arc au-dessus du cercle, à gauche, dans les mesures du design (2000 px), écriture Dancing Script
  function lettresPrenom(nom) {
    const lettres = [...nom.trim()].slice(0, MAX_NAME);
    const pas = Math.min(9.5, Math.max(4.6, 44 / Math.max(1, lettres.length - 1)));
    return lettres.map((c, k) => {
      const deg = -145 + k * pas, a = deg * Math.PI / 180;
      return { c, x: 1002 + 880 * Math.cos(a), y: 912 + 880 * Math.sin(a), r: deg + 90 };
    });
  }
  const prenomSVG = nom => lettresPrenom(nom).map(l => {
    const x = l.x.toFixed(1), y = l.y.toFixed(1);
    return `<text x="${x}" y="${y}" transform="rotate(${l.r.toFixed(1)} ${x} ${y})">${esc(l.c)}</text>`;
  }).join('');
  // Fichier imprimé : le portrait (1024 px) agrandi à 2000 px sur fond blanc, avec le prénom tracé par-dessus
  async function fichierPortrait(blob, nom) {
    try { await document.fonts.load('500 150px "Dancing Script"'); } catch (e) { /* écriture de secours */ }
    const img = await decoderImage(blob);
    const c = document.createElement('canvas');
    c.width = c.height = 2000;
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, 2000, 2000);
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, 2000, 2000);
    const donnees = ctx.getImageData(0, 0, 2000, 2000);
    blanchirFond(donnees.data, 2000, 2000);
    ctx.putImageData(donnees, 0, 0);
    ctx.fillStyle = '#1e1a1c';
    ctx.font = '500 150px "Dancing Script", cursive';
    ctx.textAlign = 'center';
    lettresPrenom(nom).forEach(l => {
      ctx.save();
      ctx.translate(l.x, l.y);
      ctx.rotate(l.r * Math.PI / 180);
      ctx.fillText(l.c, 0, 0);
      ctx.restore();
    });
    return new Promise(ok => c.toBlob(ok, 'image/jpeg', 0.92));
  }
  // Vignette du panier : le t-shirt du cintre avec SON portrait imprimé dessus (même endroit, même taille que les photos
  // produit) ; renvoie l'image (data:) pour l'affichage et le fichier pour Cloudinary (tiroir du panier de la boutique)
  async function vignettePortraitTshirt(fichierImprime) {
    const [tee, motif] = await Promise.all([fetch(PK_TEE).then(r => r.blob()).then(decoderImage), decoderImage(fichierImprime)]);
    const c = document.createElement('canvas'), k = 480 / 1100;
    c.width = c.height = 480;
    const ctx = c.getContext('2d');
    ctx.drawImage(tee, 0, 0, 480, 480);
    ctx.globalCompositeOperation = 'multiply';
    const [bx, by, bl, bh] = SAMOURAI_DIRECT ? BOITE_SAMOURAI : [-39, 351, 612, 612];
    ctx.drawImage(motif, bx * k, by * k, bl * k, bh * k);
    return { url: c.toDataURL('image/jpeg', 0.82), file: await new Promise(ok => c.toBlob(ok, 'image/jpeg', 0.85)) };
  }

  /* ===== Panier gardé dans le navigateur (7 jours) =====
     Le client qui ferme Facebook ou l'onglet retrouve son panier en revenant : tailles, prénoms, couleurs,
     identifiants des photos déjà reçues par Cloudinary, et une petite vignette de la première photo de chaque animal
     (pour l'affichage du panier). Effacé dès que la commande est payée. */
  const PANIER = PORTRAIT ? 'kp-panier-portrait' : 'kp-panier', DUREE_PANIER = 7 * 24 * 3600 * 1000;
  // Article du panier : t-shirt personnalisé { id, count, size, animals } ou modèle tout fait { id, type: 'modele', ref, size }
  const estModele = it => it.type === 'modele';
  // Boutique Shopify : le panier Shopify est tenu à l'identique du panier Kizuna (variante taille × animaux + détails)
  const TAILLE_SHOPIFY = { XXL: '2XL' };
  function varianteShopify(it) {
    const taille = TAILLE_SHOPIFY[it.size] || it.size, nb = it.count > 1 ? `${it.count} animaux` : '1 animal';
    const v = (window.KZ.variantes || []).find(x => x.option1 === taille && (x.option2 == null || x.option2 === nb));
    return v && v.id;
  }
  function proprietesShopify(it) {
    const p = {};
    it.animals.forEach((a, k) => {
      const c = colorById(a.color);
      p[`Animal ${k + 1} - Prénom`] = a.name;
      if (!PORTRAIT) p[`Animal ${k + 1} - Couleur du kimono`] = c ? c.label : a.color; // portrait : toujours le même kimono
      // une propriété par photo : Shopify affiche chaque lien à part (plusieurs liens collés dans une seule propriété = lien cassé)
      const liens = a.liens || [];
      if (!liens.length) p[`Animal ${k + 1} - Photo`] = '(photo à demander)';
      liens.forEach((l, i) => { p[`Animal ${k + 1} - Photo ${i + 1}`] = l; });
    });
    if (PORTRAIT) p.Style = 'Portrait kimono';
    // Portrait créé sur la page : le fichier à imprimer (portrait + prénom) et la vignette du tiroir du panier ; pas d'aperçu par mail
    if (it.portrait) {
      p[PORTRAIT ? 'Portrait à imprimer' : 'Design à imprimer'] = it.design || '(en cours d\'envoi)';
      if (it.vignetteLien) p._Vignette = it.vignetteLien;
    } else p['Aperçu par mail'] = it.surprise ? 'Non, garder la surprise' : 'Oui'; // comme l'ancien bloc de la boutique
    p._kz = String(it.id); // repère (caché) : retrouver la ligne Shopify de ce t-shirt
    return p;
  }
  // Un t-shirt perso retiré dans le panier de la boutique (déjà envoyé à Shopify mais absent du panier Shopify) est
  // retiré d'ici aussi, sinon il reviendrait au prochain ajout
  let sansSynchro = false;
  const ecrireStockage = () => { sansSynchro = true; try { sauverPanier(); } finally { sansSynchro = false; } };
  function reconcilier(perso) {
    const presents = new Set(perso.map(l => String((l.properties || {})._kz || '')));
    let change = false;
    for (let k = cart.length - 1; k >= 0; k--) if (cart[k].synchro && !presents.has(String(cart[k].id))) { cart.splice(k, 1); change = true; }
    if (change) { ecrireStockage(); renderCart(); }
  }
  // Seules les lignes des t-shirts personnalisés (propriété « Animal 1 - Prénom ») sont remplacées : les autres articles
  // de la boutique restent dans le panier Shopify (méga offre « au choix dans toute la boutique »)
  const estPerso = l => !!(l.properties && l.properties['Animal 1 - Prénom']) && (!window.KZ || !window.KZ.produit || l.product_id === window.KZ.produit);
  // Autres t-shirts du panier Shopify (articles livrés d'au moins 30 €) : comptés dans la jauge et montrés par leur nom
  const estTshirt = l => l.requires_shipping !== false && l.price >= 3000;
  let autresArticles = 0, autresListe = [];
  const lireCartShopify = () => fetch('/cart.js', { cache: 'no-store' }).then(r => r.json()).then(c => {
    autresListe = c.items.filter(l => !estPerso(l) && estTshirt(l));
    autresArticles = autresListe.reduce((s, l) => s + l.quantity, 0);
    return c.items.filter(estPerso);
  });
  let synchro = lireCartShopify().then(perso => { reconcilier(perso); renderCart(); }).catch(() => {}), minuteurSynchro;
  function synchroniserShopify() {
    if (sansSynchro) return;
    clearTimeout(minuteurSynchro);
    minuteurSynchro = setTimeout(() => {
      const json = { 'Content-Type': 'application/json' };
      let items = [];
      synchro = synchro.then(lireCartShopify)
        .then(perso => {
          reconcilier(perso);
          items = cart.map(it => ({ id: varianteShopify(it), quantity: 1, properties: proprietesShopify(it) })).filter(x => x.id);
          return perso.length ? fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: Object.fromEntries(perso.map(l => [l.key, 0])) }) }) : null;
        })
        .then(() => (items.length ? fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items }) }) : null))
        .then(r => {
          if (r && r.ok) { cart.forEach(it => { it.synchro = true; }); ecrireStockage(); }
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); // panier de la boutique et compteur de l'en-tête
          renderCart();
        })
        .catch(() => {});
    }, 250);
  }
  function sauverPanier() {
    synchroniserShopify();
    try {
      const prets = cart.filter(it => estModele(it) || (it.animals.every(a => a.ids && a.ids.length) && (!it.portrait || it.design)));
      if (!prets.length) { localStorage.removeItem(PANIER); return; }
      localStorage.setItem(PANIER, JSON.stringify({ t: Date.now(), cart: prets.map(it => (estModele(it)
        ? { id: it.id, type: 'modele', ref: it.ref, size: it.size }
        : { id: it.id, count: it.count, size: it.size, surprise: !!it.surprise, synchro: !!it.synchro, portrait: !!it.portrait, design: it.design || '', vignetteLien: it.vignetteLien || '',
          animals: it.animals.map(a => ({ name: a.name, color: a.color, ids: a.ids, liens: a.liens || [], vignette: a.vignette || '' })) })) }));
    } catch (e) { /* stockage plein ou bloqué : le panier reste dans l'onglet */ }
  }
  // Remet le panier gardé (s'il a moins de 7 jours) ; renvoie true si un panier a été retrouvé
  function restaurerPanier() {
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem(PANIER)); } catch (e) { saved = null; }
    if (!saved || !Array.isArray(saved.cart) || !saved.cart.length || !(Date.now() - saved.t < DUREE_PANIER)) {
      try { localStorage.removeItem(PANIER); } catch (e) { /* rien */ }
      return false;
    }
    // Un modèle retiré du catalogue entre-temps n'est pas remis
    const remis = saved.cart.filter(it => !estModele(it) || modeleParId(it.ref));
    cart.push(...remis.map(it => (estModele(it) ? it : { ...it, animals: it.animals.map(a => ({ ...a, photos: a.vignette ? [a.vignette] : [] })) })));
    return cart.length > 0;
  }
  // Vignette carrée de 160 px (JPEG) d'une photo ; format illisible par le navigateur (HEIC…) : pas de vignette
  async function vignettePhoto(photo) {
    if (!photo || !photo.file) return '';
    try {
      await photo.pret;
      const img = await decoderImage(photo.file);
      const s = 160 / Math.min(img.width, img.height), c = document.createElement('canvas');
      c.width = c.height = 160;
      c.getContext('2d').drawImage(img, (160 - img.width * s) / 2, (160 - img.height * s) / 2, img.width * s, img.height * s);
      return c.toDataURL('image/jpeg', 0.7);
    } catch (e) { return ''; }
  }

  /* ===== Prix & offre « 2 achetés = 1 offert » ===== */
  // Les prix sont toujours calculés dans la devise en cours (G) : changer de pays met tout à jour, panier compris.
  // Remise d'une liste de t-shirts (prix normaux) : le moins cher de chaque groupe de 3 est offert, -10 € pour un t-shirt
  // payé seul, -25 € par paire (assets/js/prix.js, même calcul au serveur)
  const remiseDe = prix => window.KP_REMISE(G, prix);
  // MÉGA OFFRE « 2 achetés = 1 offert » jusqu'au 30 novembre (assets/js/prix.js) : ensuite, ses bandeaux disparaissent
  const FIN_OFFRE = Date.parse(window.KP_FIN_OFFRE);
  const offreActive = () => Date.now() < FIN_OFFRE;
  const remise = n => remiseDe(Array.from({ length: Math.max(0, n) }, () => G.prixBase)); // n t-shirts à 1 animal
  // Modèle tout fait : pas d'animaux, donc pas de supplément (count absent)
  const teeRegular = t => G.prixBase + (G.supplements[t.count] || 0);
  const bundleOld = q => state.tees.slice(0, q).reduce((s, t) => s + teeRegular(t), 0);
  const bundleRemise = q => remiseDe(state.tees.slice(0, q).map(teeRegular));
  const configOld = () => bundleOld(state.qty);
  const configTotal = () => configOld() - bundleRemise(state.qty);
  // Panier : sous-total (prix normaux), remise, et articles offerts (les moins chers, un par groupe de 3)
  function totauxPanier() {
    const prix = cart.map(teeRegular);
    const sousTotal = prix.reduce((s, p) => s + p, 0), r = remiseDe(prix);
    const offerts = new Set(prix.map((p, i) => [p, i]).sort((a, b) => a[0] - b[0] || b[1] - a[1]).slice(0, Math.floor(prix.length / 3)).map(x => x[1]));
    return { sousTotal, remise: r, total: Math.round((sousTotal - r) * 100) / 100, offerts };
  }

  function renderPrices() {
    $$('[data-price="unit"]').forEach(el => { el.textContent = money(configTotal()); });
    $$('[data-price="unit-old"]').forEach(el => { el.textContent = money(configOld()); });
    $$('[data-price="save"]').forEach(el => { el.textContent = `-${euros(bundleRemise(state.qty))}`; });
    $$('[data-price="from"]').forEach(el => { el.textContent = money(G.prixBase - remise(1)); });
    $$('[data-price="regular"]').forEach(el => { el.textContent = money(G.prixBase); });
    // Montants écrits dans les textes de la page (bandeau, FAQ…) : data-m="r1" (remise pour 1 t-shirt), "s2" (supplément 2 animaux)…
    $$('[data-m]').forEach(el => {
      const [k, n] = [el.dataset.m[0], +el.dataset.m.slice(1)];
      el.textContent = k === 'r' ? `-${euros(remise(n))}` : `+${euros(G.supplements[n])}`;
    });
    renderBundle();
    flashPrices();
  }

  // Petit effet visuel quand le prix change, pour qu'on le remarque
  let pricesReady = false; // passe à true une fois la page chargée
  function flashPrices() {
    if (!pricesReady) return;
    $$('.config__price, #addToCart').forEach(el => {
      el.classList.remove('is-updated'); void el.offsetWidth; el.classList.add('is-updated');
    });
  }

  /* ===== Toast ===== */
  const toastEl = $('#toast');
  let toastTimer;
  function toast(msg) {
    toastEl.innerHTML = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 3600);
  }

  /* =========================================================
     1. OFFRE : 1, 2 ou 3 t-shirts
     ========================================================= */
  const bundleEl = $('#bundle');
  function renderBundle() {
    // Les cases sont créées une seule fois, puis seulement mises à jour :
    // la carte blanche peut ainsi glisser d'une offre à l'autre.
    if (!bundleEl.children.length) {
      bundleEl.innerHTML = '<span class="bundle__ind" aria-hidden="true"></span>' + [1, 2, 3].map(q => `
        <button type="button" class="bundle__opt" data-qty="${q}" role="radio">
          ${q === 2 ? `<span class="bundle__flag">${L.popular}</span>` : ''}
          <svg class="bundle__fleur" viewBox="0 0 24 24" aria-hidden="true">${[0, 72, 144, 216, 288].map(a => `<path transform="rotate(${a} 12 12)" d="M12 12C8.6 9.4 8.8 4.6 10.9 3.1L12 4.4l1.1-1.3c2.1 1.5 2.3 6.3-1.1 8.9z"/>`).join('')}<circle cx="12" cy="12" r="1.7" fill="#fff"/></svg>
          <span class="bundle__save"><span class="sm-hide"></span><span class="sm-only"></span></span>
          <span class="bundle__q">${L.tees(q)}</span>
          <b class="bundle__now"></b>
          <s class="bundle__old"></s>
        </button>`).join('');
    }
    bundleEl.style.setProperty('--i', state.qty - 1);
    $$('.bundle__opt', bundleEl).forEach(b => {
      const q = +b.dataset.qty;
      const old = bundleOld(q);
      const now = old - bundleRemise(q);
      const on = q === state.qty;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on);
      b.setAttribute('aria-label', L.bundleAria(q, money(now), money(old)));
      // Méga offre : une seule promesse, « 3e offert » sur 3 t-shirts (le prix barré dit déjà le reste) ;
      // après l'offre : le montant de la remise
      const etiquette = offreActive() ? (q === 3 ? L.thirdFree : '') : null;
      $('.bundle__save .sm-hide', b).textContent = etiquette ?? `-${euros(bundleRemise(q))}`;
      $('.bundle__save .sm-only', b).textContent = etiquette ?? L.bundleSaveShort(euros(bundleRemise(q)), q);
      $('.bundle__save', b).hidden = etiquette === '';
      $('.bundle__now', b).textContent = money(now);
      $('.bundle__old', b).textContent = money(old);
    });

    // Plus de message « Déjà N t-shirt(s) dans le panier… » (retiré à la demande du propriétaire, 18/10)
    const note = $('#bundleNote');
    note.hidden = true;
    note.textContent = '';
  }
  bundleEl.addEventListener('click', e => {
    const b = e.target.closest('[data-qty]');
    if (!b) return;
    setQty(+b.dataset.qty); // la page reste où elle est (le propriétaire ne veut plus de descente automatique)
  });

  function setQty(q, focusNew) {
    const before = state.qty;
    state.qty = q;
    if (state.activeTee >= q) { state.activeTee = q - 1; state.activeAnimal = 0; }
    renderTees();
    renderPrices();
    updatePreview(false);
    if (q > before) {
      // Les nouvelles cartes s'illuminent pour montrer qu'elles sont apparues en dessous
      for (let k = before; k < q; k++) $(`.tb[data-tee="${k}"]`, teesEl).classList.add('is-new');
      setTimeout(() => $$('.tb.is-new', teesEl).forEach(el => el.classList.remove('is-new')), 2600);
      if (focusNew) $(`.tb[data-tee="${q - 1}"]`, teesEl).scrollIntoView({ behavior: smooth(), block: 'start' });
    }
  }

  /* =========================================================
     2. CARTES T-SHIRT : tout sur la même page, 1 colonne par animal
     ========================================================= */
  const teesEl = $('#tees');
  const ICON = id => `<svg class="ic"><use href="#${id}"/></svg>`;

  function uploadHTML(t, a) {
    const photos = t.animals[a].photos;
    const multi = t.count > 1;
    const thumbs = photos.length
      ? `<div class="up__thumbs">${photos.map((p, i) => `
          <span class="up__thumb${p.status === 'uploading' ? ' is-uploading' : ''}${p.status === 'error' ? ' is-error' : ''}"${p.status === 'error' ? ` title="${esc(L.uploadFailed)}"` : ''}><img src="${p.url}" alt="${esc(L.photoN(i + 1))}" data-broken="thumb">
            <button type="button" data-act="photo-del" data-animal="${a}" data-i="${i}" aria-label="${esc(L.removePhoto)}">${ICON('i-x')}</button>
          </span>`).join('')}</div>`
      : '';
    // Page portrait : une seule photo, celle qui sert à créer le portrait
    const max = DIRECT ? 1 : MAX_PHOTOS;
    const add = photos.length < max
      ? `<label class="up__add">
          <input type="file" accept="image/*"${DIRECT ? '' : ' multiple'} hidden data-act="file" data-animal="${a}">
          ${ICON('i-camera')}
          <span class="up__t">${DIRECT ? L.pkImporter : photos.length ? L.upAdd : multi ? L.upPhotos : L.upImport}</span>
          <span class="up__s">${photos.length ? `${photos.length}/${max}` : multi ? L.upUpTo3 : DIRECT ? (isTouch ? L.upTouch.split(' · ')[0] : '') : (isTouch ? L.upTouch : L.upDesk)}</span>
        </label>`
      : '';
    return `<div class="up${photos.length ? ' has-photos' : ''}" data-up="${a}">${thumbs}${add}</div>`;
  }


  // Page portrait : l'aperçu en direct, sur le t-shirt du cintre (sous les champs, au-dessus du bouton du panier)
  function portraitHTML(t, k) {
    const p = t.portrait, a = t.animals[0], photo = a.photos[0];
    const pret = p.etat === 'pret';
    // Toujours sur le t-shirt (jamais le portrait seul)
    const scene = `<img class="pk__tee" src="${PK_TEE}" alt="" width="1100" height="1100">
        ${pret && SAMOURAI_DIRECT ? `<div class="pk__samourai"><img src="${p.urlDessin}" alt="${esc(L.pkAlt)}" style="left:${((900 - p.dessin.l) / 9).toFixed(2)}%;top:${((1050 - p.dessin.h) / 10.5).toFixed(2)}%;width:${(p.dessin.l / 9).toFixed(2)}%"><svg viewBox="0 0 900 1050" aria-hidden="true"><g class="pk__nomj">${nomSamouraiSVG(a.name, kanaDe(p)(a.name), couleurNom(p.couleur), p.dessin)}</g></svg></div>` : ''}
        ${pret && !SAMOURAI_DIRECT ? `<img class="pk__motif" src="${p.url}" alt="${esc(L.pkAlt)}">` : ''}
        <svg class="pk__calque" viewBox="0 0 1100 1100" aria-hidden="true">
          ${pret && !SAMOURAI_DIRECT ? `<g class="pk__nom" transform="translate(-39 351) scale(0.306)">${prenomSVG(a.name)}</g>` : ''}
          ${photo ? `<clipPath id="pkBulle${k}"><circle cx="828.8" cy="262" r="236"/></clipPath>
          <image href="${esc(photo.url)}" x="592.8" y="26" width="472" height="472" preserveAspectRatio="xMidYMid slice" clip-path="url(#pkBulle${k})"/>
          <circle cx="828.8" cy="262" r="239.8" fill="none" stroke="#141212" stroke-width="8"/>
          <image href="${PK_FLECHE}" x="661" y="505" width="141" height="130"/>` : ''}
        </svg>
        ${p.etat === 'creation' ? `<div class="pk__rond pk__rond--attente"><span class="pk__sceau" aria-hidden="true">絆</span><strong data-pk-msg>${L.pkCreation}</strong><span class="pk__barre"><i data-pk-barre></i></span></div>` : ''}
        ${p.etat === 'vide' ? `<div class="pk__rond">${photo ? '' : ICON('i-camera')}<span>${SAMOURAI_DIRECT ? (photo && !a.color ? L.pkCouleurAvant : L.pkVide.replace('20', '25')) : L.pkVide}</span></div>` : ''}
        ${p.etat === 'erreur' ? `<div class="pk__rond pk__rond--erreur"><span>${esc(p.erreur)}</span>${p.essais < MAX_PORTRAITS && photo ? `<button type="button" class="pk__btn" data-act="portrait-refaire">${L.pkReessayer}</button>` : ''}</div>` : ''}`;
    const reste = MAX_PORTRAITS - p.essais;
    // Pas encore de photo : toucher le t-shirt vide ouvre le choix de la photo (comme « Sa photo » plus haut)
    const choisir = p.etat === 'vide' && !photo;
    const sous = pret
      ? `<p class="pk__info">${ICON('i-check')} <span>${L.pkPret}</span></p>
        ${reste > 0 ? `<button type="button" class="link-btn pk__autre" data-act="portrait-refaire">${ICON('i-sparkle')} ${L.pkAutre(reste)}</button>` : ''}`
      : p.etat === 'creation' ? `<p class="pk__info pk__info--attente">${L.pkAstuce}</p>` : '';
    return `<div class="pk" data-pk="${k}">
      ${choisir
        ? `<label class="pk__scene pk__scene--choisir"><input type="file" accept="image/*" hidden data-act="file" data-animal="0">${scene}</label>`
        : `<div class="pk__scene">${scene}</div>`}
      ${sous}
    </div>`;
  }
  // Fichier imprimé et vignette du panier, préparés et envoyés à l'avance (dès que le portrait est prêt, puis à chaque
  // nouveau prénom) : à l'ajout au panier, ils sont déjà sur Cloudinary
  function preparerFichiers(t) {
    const p = t.portrait, nom = t.animals[0].name.trim();
    const kana = SAMOURAI_DIRECT ? kanaDe(p)(nom) : '';
    if (p.fichiers && p.fichiers.nom === nom && p.fichiers.url === p.url && p.fichiers.kana === kana) return p.fichiers;
    const design = { pret: fichierDesign(t).then(b => { design.file = b; }) };
    const vignette = { pret: design.pret.then(() => vignettePortraitTshirt(design.file)).then(v => { vignette.file = v.file; vignette.url = v.url; }) };
    uploadPhoto(design);
    // vignette du tiroir du panier demandée tout de suite à Cloudinary (même format que le tiroir) : déjà prête à son ouverture
    uploadPhoto(vignette).then(() => { if (vignette.lien) new Image().src = vignette.lien.replace('/upload/', '/upload/c_fill,w_200,h_200,f_auto,q_auto/'); });
    return (p.fichiers = { nom, url: p.url, kana, design, vignette });
  }
  let minuteurFichiers = null;
  function preparerPlusTard(k) {
    clearTimeout(minuteurFichiers);
    minuteurFichiers = setTimeout(() => { const t = state.tees[k]; if (t.portrait.etat === 'pret' && t.animals[0].name.trim()) preparerFichiers(t); }, 1200);
  }
  function renderPortrait(k) {
    const el = $(`.tb[data-tee="${k}"] [data-pk]`, teesEl);
    if (el) el.outerHTML = portraitHTML(state.tees[k], k);
  }
  // Prénom tapé : mis à jour en direct sur le portrait affiché
  function majPrenomPortrait(k, kanaAJour) {
    if (SAMOURAI_DIRECT) {
      const t = state.tees[k], p = t.portrait, nom = t.animals[0].name;
      if (!kanaAJour && p.kanaNom !== nom.trim()) demanderKana(k);
      $$(`.tb[data-tee="${k}"] .pk__nomj`, teesEl).forEach(g => { g.innerHTML = nomSamouraiSVG(nom, kanaDe(p)(nom), couleurNom(p.couleur), p.dessin); });
      return;
    }
    const nom = state.tees[k].animals[0].name;
    $$(`.tb[data-tee="${k}"] .pk__nom`, teesEl).forEach(g => { g.innerHTML = prenomSVG(nom); });
  }
  // Photo réduite à 768 px (JPEG, base64) pour le générateur
  async function photoPourPortrait(photo) {
    await photo.pret;
    const img = await decoderImage(photo.file);
    const s = Math.min(1, 768 / Math.max(img.width, img.height)), c = document.createElement('canvas');
    c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', 0.85).split(',')[1];
  }
  async function creerPortrait(k) {
    const t = state.tees[k], p = t.portrait, photo = t.animals[0].photos[0];
    if (!photo) return;
    if (SAMOURAI_DIRECT && !t.animals[0].color) { renderPortrait(k); return; } // la couleur du kimono d'abord
    if (p.essais >= MAX_PORTRAITS) { toast(L.pkMax); return; }
    if (p.ctrl) p.ctrl.abort();
    const ctrl = p.ctrl = new AbortController();
    p.essais++;
    Object.assign(p, { etat: 'creation', erreur: '' });
    renderPortrait(k);
    refreshErrors(k);
    mesurer('apercu_demande');
    const debut = Date.now();
    const minuteur = setInterval(() => {
      const card = $(`.tb[data-tee="${k}"]`, teesEl), s = (Date.now() - debut) / 1000;
      if (!card || ctrl !== p.ctrl) return;
      const barre = $('[data-pk-barre]', card), msg = $('[data-pk-msg]', card);
      if (barre) barre.style.width = Math.min(95, s / DUREE_PORTRAIT * 100) + '%';
      if (msg) msg.textContent = s < 8 ? L.pkCreation : s < 16 ? L.pkEncre : L.pkFin;
    }, 500);
    try {
      const image = await photoPourPortrait(photo);
      // jeton du jour (même calcul que le générateur de la boutique) écrit par la page (window.KZ.jeton)
      const couleur = t.animals[0].color, nom = t.animals[0].name.trim();
      p.couleurDemandee = couleur;
      const r = await fetch(SAMOURAI_DIRECT ? API_SAMOURAI : API_PORTRAIT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrl.signal,
        body: JSON.stringify(SAMOURAI_DIRECT ? { token: window.KZ.jeton, image, color: COULEUR_API[couleur], petName: nom, rendu: 'kizuna' } : { token: window.KZ.jeton, image })
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.image) throw new Error(r.status === 429 ? L.pkLimite : L.pkErreur);
      const blob = new Blob([Uint8Array.from(atob(d.image), c => c.charCodeAt(0))], { type: SAMOURAI_DIRECT ? 'image/png' : 'image/jpeg' });
      if (ctrl !== p.ctrl) return;
      if (SAMOURAI_DIRECT) {
        // dessin samouraï : sa couleur, le haut du dessin (le prénom se pose au-dessus) et le japonais du prénom déjà tapé
        p.couleur = couleur;
        const dessin = await rognerDessin(blob);
        Object.assign(p, { dessin: { l: dessin.l, h: dessin.h }, blobDessin: dessin.blob, urlDessin: URL.createObjectURL(dessin.blob) });
        const kana = String(d.japaneseName || '').replace(/[^\u3040-\u30ff\u3400-\u9fff\uff66-\uff9f・ー]/g, '').slice(0, 12);
        if (nom && kana) { p.kana = kana; p.kanaNom = nom; }
        if (ctrl !== p.ctrl) return;
      }
      // (l'ancienne image n'est pas libérée : un t-shirt déjà au panier peut encore l'afficher)
      Object.assign(p, { etat: 'pret', blob, url: URL.createObjectURL(blob) });
      mesurer('apercu_vu');
      if (t.animals[0].name.trim()) preparerFichiers(t);
    } catch (e) {
      if (ctrl !== p.ctrl) return;
      // Création qui n'a pas abouti : elle ne compte pas dans les 3 essais
      Object.assign(p, { etat: 'erreur', erreur: e.message === L.pkLimite ? L.pkLimite : L.pkErreur });
      p.essais = Math.max(0, p.essais - 1);
    } finally {
      clearInterval(minuteur);
    }
    p.ctrl = null;
    renderPortrait(k);
    refreshErrors(k);
  }

  function teeHTML(t, k) {
    const n = t.count;
    const cols = fn => Array.from({ length: n }, (_, a) => fn(a)).join('');
    // « Animal 1 / 2 / 3 » au-dessus de chaque colonne (seulement s'il y a plusieurs animaux)
    const colLabels = n > 1 ? `<div class="tb__cols tb__collabels" aria-hidden="true">${cols(a => `<span>${L.animalN(a + 1)}</span>`)}</div>` : '';
    const title = state.qty > 1 ? L.teeN(k + 1) : L.yourTee;
    // Page portrait : la photo d'abord (la création démarre aussitôt), puis le prénom, la taille, et en dernier l'aperçu
    const champPhoto = `
        <div class="tb__field" data-f="photo">
          <div class="tb__label-row">
            <span class="tb__label">${DIRECT ? L.pkPhoto : L.photosLabel} <span class="req">*</span> <small>${DIRECT ? L.pkPhotoAide : L.photosPer}</small></span>
            <button type="button" class="link-btn" data-open-tips>${ICON('i-camera')} ${L.photoTips}</button>
          </div>
          ${colLabels}
          <div class="tb__cols">${cols(a => uploadHTML(t, a))}</div>
          <p class="error" data-err="photo" role="alert"></p>
        </div>`;
    const champTaille = `
        <div class="tb__field" data-f="size">
          <div class="tb__label-row">
            <span class="tb__label">${L.size} <span class="req">*</span></span>
            <button type="button" class="link-btn" data-open-size>${ICON('i-ruler')} ${L.sizeGuide}</button>
          </div>
          <div class="tb__sizes" role="radiogroup" aria-label="${esc(L.size)}">
            ${SIZES.map(s => `<button type="button" class="size${t.size === s ? ' is-active' : ''}" data-act="size" data-size="${s}" role="radio" aria-checked="${t.size === s}">${s}</button>`).join('')}
          </div>
          <p class="error" data-err="size" role="alert"></p>
        </div>`;
    return `
      <article class="tb" data-tee="${k}" data-cols="${n}" style="--cols:${n}" aria-label="${esc(title)}">
        <header class="tb__head">
          <span class="tb__title">${ICON('i-shirt')} ${title}</span>
          <span class="tb__actions">
            <span class="tb__ok">${ICON('i-check')} ${L.ready}</span>
            ${state.qty > 1 ? `<button type="button" class="tb__remove" data-act="remove" aria-label="${esc(L.removeTee(k + 1))}">${ICON('i-x')}</button>` : ''}
          </span>
        </header>

        <div class="tb__field"${PORTRAIT || DIRECT ? ' hidden' : ''}>
          <span class="tb__label">${L.animalsOnTee}</span>
          <div class="seg" role="radiogroup" aria-label="${esc(L.animalsCount)}">
            ${[1, 2, 3].map(c => `
              <button type="button" class="seg__btn${c === n ? ' is-active' : ''}" data-act="count" data-n="${c}" role="radio" aria-checked="${c === n}">
                <span class="seg__paws">${ICON('i-paw').repeat(c)}</span>
                <span class="seg__n">${L.animals(c)}</span>
                <span class="seg__p">${c === 1 ? L.included : '+' + euros(G.supplements[c])}</span>
              </button>`).join('')}
          </div>
        </div>

        ${DIRECT ? '' : champTaille}
        ${DIRECT ? champPhoto : ''}
        <div class="tb__field" data-f="name">
          <span class="tb__label">${n > 1 ? L.namesLabel : L.nameLabel} <span class="req">*</span></span>
          ${colLabels}
          <div class="tb__cols">${cols(a => `
            <input class="input" type="text" data-act="name" data-animal="${a}" maxlength="${MAX_NAME}" value="${esc(t.animals[a].name)}"
              placeholder="${esc(n > 1 ? L.nameN(a + 1) : L.namePh)}" autocomplete="off" autocapitalize="words" spellcheck="false"
              aria-label="${esc(L.nameAria(a + 1))}">`)}</div>
          <p class="hint">${ICON('i-sparkle')} ${L.nameHint(n)}</p>
          <p class="error" data-err="name" role="alert"></p>
        </div>

        <div class="tb__field" data-f="color"${PORTRAIT ? ' hidden' : ''}>
          <span class="tb__label">${L.colorLabel} <span class="req">*</span></span>
          ${colLabels}
          <div class="tb__cols">${cols(a => {
            const c = colorById(t.animals[a].color);
            return `
              <button type="button" class="cpick${c ? ' is-set' : ''}" data-act="color-open" data-animal="${a}" aria-expanded="false">
                <i class="cpick__dot${c && !c.hex ? ' is-surprise' : ''}" style="${c && c.hex ? `--c:${c.hex}` : ''}"></i>
                <span class="cpick__t">${c ? c.label : n > 1 ? L.choose : L.chooseColor}</span>
                ${ICON('i-chevron')}
              </button>`;
          })}</div>
          <div class="cpop" data-pop hidden>
            <p class="cpop__title" data-pop-title></p>
            <div class="cpop__grid">${COLORS.filter(c => c.hex && !c.retire).map(c => `
              <button type="button" class="cpop__opt" data-act="color" data-color="${c.id}">
                <i style="--c:${c.hex}"></i>${c.label}
              </button>`).join('')}</div>
          </div>
          <p class="error" data-err="color" role="alert"></p>
        </div>

        ${DIRECT ? '' : champPhoto}

        <div class="tb__field tb__apercu" data-f="apercu"${DIRECT ? ' hidden' : ''}>
          <span class="tb__label">${ICON('i-mail')} ${L.apercuQ}</span>
          <div class="apercu-opts" role="radiogroup" aria-label="${esc(L.apercuQ)}">
            <button type="button" class="apercu-opt${t.surprise ? '' : ' is-active'}" data-act="apercu" data-v="oui" role="radio" aria-checked="${!t.surprise}"><i></i>${L.apercuOui}</button>
            <button type="button" class="apercu-opt${t.surprise ? ' is-active' : ''}" data-act="apercu" data-v="non" role="radio" aria-checked="${!!t.surprise}"><i></i>${L.apercuNon}</button>
          </div>
        </div>
        ${DIRECT ? champTaille + `
        <div class="tb__field" data-f="portrait">
          ${portraitHTML(t, k)}
          <p class="error" data-err="portrait" role="alert"></p>
        </div>` : ''}
      </article>`;
  }

  // Lien entre deux cartes : « Ensuite, le t-shirt 2 » (cliquable, descend jusqu'à la carte suivante)
  const nextHTML = k => `
    <button type="button" class="tb-next" data-goto="${k + 1}">
      <span class="tb-next__ic">${ICON('i-chevron')}</span>
      <span class="tb-next__t">${L.nextTee(k + 2)}</span>
    </button>`;

  function renderTees() {
    const q = state.qty;
    teesEl.innerHTML = state.tees.slice(0, q).map((t, k) => teeHTML(t, k) + (k < q - 1 ? nextHTML(k) : '')).join('');
    $('#teesTitle').textContent = q > 1 ? L.customizeN(q) : L.customize1;
    const add = $('#addTee');
    add.hidden = q >= 3;
    if (q < 3) {
      add.innerHTML = `${ICON('i-plus')} ${offreActive() ? (q + 1 === 3 ? L.addThirdFree : L.addTeeSimple(q + 1)) : L.addTee(q + 1, euros(remise(q + 1)))}`;
    }
    renderProgress();
  }

  function renderTee(k) {
    const el = $(`.tb[data-tee="${k}"]`, teesEl);
    if (!el) return;
    const showErrors = el.classList.contains('show-errors');
    el.outerHTML = teeHTML(state.tees[k], k);
    if (showErrors) checkTee(k);
    renderProgress();
  }

  /* Suivi du remplissage quand il y a 2 ou 3 t-shirts :
     1 → 2 → 3 sous le titre, « Prêt » sur chaque carte complète,
     et le lien entre les cartes qui passe en rose quand c'est au tour du suivant. */
  let lastDone = [];
  function renderProgress() {
    const q = state.qty;
    const done = state.tees.slice(0, q).map(teeComplete);
    const cur = done.indexOf(false); // premier t-shirt à compléter (-1 = tous prêts)
    const steps = $('#teeSteps');
    steps.hidden = q < 2;
    if (q > 1) {
      $('.tsteps__list', steps).innerHTML = done.map((d, k) => `
        <li class="tsteps__i${d ? ' is-done' : ''}${k === cur ? ' is-current' : ''}">
          <button type="button" class="tsteps__btn" data-goto="${k}" aria-label="${esc(L.stepAria(k + 1, d))}">
            <span class="tsteps__dot">${d ? ICON('i-check') : k + 1}</span>
            <span class="tsteps__t">${L.teeN(k + 1)}</span>
          </button>
        </li>`).join('');
      $('.tsteps__hint', steps).innerHTML =
        cur === -1 ? `${ICON('i-check')} <span>${L.hintAllReady(q)}</span>`
        : cur === 0 ? `<span>${L.hintStart(q)}</span>`
        : `${ICON('i-check')} <span>${L.hintNext(cur)}</span>`;
    }
    $$('.tb', teesEl).forEach(card => card.classList.toggle('is-complete', done[+card.dataset.tee]));
    $$('.tb-next', teesEl).forEach(el => {
      const k = +el.dataset.goto - 1; // la carte juste au-dessus
      el.classList.toggle('is-ready', done[k]);
      $('.tb-next__t', el).textContent = done[k] ? L.nextReady(k + 1) : L.nextTee(k + 2);
      if (done[k] && lastDone[k] === false) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
    });
    lastDone = done;
  }

  // Clic sur le suivi ou sur un lien entre cartes : on descend jusqu'au t-shirt
  document.addEventListener('click', e => {
    const go = e.target.closest('[data-goto]');
    if (!go) return;
    const card = $(`.tb[data-tee="${go.dataset.goto}"]`, teesEl);
    if (card) card.scrollIntoView({ behavior: smooth(), block: 'start' });
  });

  function renderUpload(k, a) {
    const el = $(`.tb[data-tee="${k}"] [data-up="${a}"]`, teesEl);
    if (el) el.outerHTML = uploadHTML(state.tees[k], a);
  }

  function setActive(k, a, switchColor) {
    state.activeTee = k;
    if (a != null) state.activeAnimal = a;
    if (state.activeAnimal >= state.tees[k].count) state.activeAnimal = 0;
    updatePreview(!!switchColor);
  }

  // Tous les clics / saisies des cartes passent par ici
  teesEl.addEventListener('click', e => {
    const btn = e.target.closest('[data-act]');
    if (!btn) return;
    const card = btn.closest('.tb');
    const k = +card.dataset.tee;
    const t = state.tees[k];
    const a = btn.dataset.animal != null ? +btn.dataset.animal : null;

    switch (btn.dataset.act) {
      case 'count':
        t.count = +btn.dataset.n;
        renderTee(k);
        renderPrices();
        setActive(k, 0);
        break;
      case 'apercu':
        t.surprise = btn.dataset.v === 'non';
        $$('[data-act="apercu"]', card).forEach(o => { const on = o === btn; o.classList.toggle('is-active', on); o.setAttribute('aria-checked', on); });
        break;
      case 'size':
        t.size = btn.dataset.size;
        mesurer('taille_choisie');
        $$('.size', card).forEach(s => { const on = s === btn; s.classList.toggle('is-active', on); s.setAttribute('aria-checked', on); });
        refreshErrors(k);
        break;
      case 'color-open': {
        const pop = $('[data-pop]', card);
        const same = !pop.hidden && +pop.dataset.animal === a;
        closePops();
        if (!same) {
          pop.dataset.animal = a;
          $('[data-pop-title]', pop).textContent = t.count > 1 ? L.popTitleN(a + 1) : L.popTitle;
          $$('.cpop__opt', pop).forEach(o => o.classList.toggle('is-active', o.dataset.color === t.animals[a].color));
          pop.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          btn.classList.add('is-open');
        }
        setActive(k, a, true);
        break;
      }
      case 'color': {
        const pop = btn.closest('[data-pop]');
        const ai = +pop.dataset.animal;
        t.animals[ai].color = btn.dataset.color;
        mesurer('couleur_choisie');
        renderTee(k);
        setActive(k, ai, true);
        if (SAMOURAI_DIRECT && t.animals[0].photos.length) {
          const p = t.portrait;
          if (p.etat === 'creation' ? p.couleurDemandee !== t.animals[0].color : (p.etat !== 'pret' || p.couleur !== t.animals[0].color)) {
            // 3 créations faites : le dernier dessin est gardé, avec sa couleur
            if (p.etat === 'pret' && p.essais >= MAX_PORTRAITS) { t.animals[0].color = p.couleur; toast(L.pkMax); renderTee(k); }
            else creerPortrait(k);
          }
        }
        break;
      }
      case 'photo-del':
        t.animals[a].photos.splice(+btn.dataset.i, 1);
        // Page portrait : nouvelle photo = nouveau portrait (sauf si les 3 créations sont faites : on garde le dernier)
        if (DIRECT) {
          const p = t.portrait;
          if (p.ctrl) { p.ctrl.abort(); p.ctrl = null; }
          if (p.essais < MAX_PORTRAITS || p.etat !== 'pret') p.etat = 'vide';
          renderPortrait(k);
        }
        renderUpload(k, a);
        refreshErrors(k);
        setActive(k, a);
        break;
      case 'portrait-refaire':
        creerPortrait(k);
        break;
      case 'remove':
        state.tees.splice(k, 1);
        state.tees.push(newTee());
        setQty(state.qty - 1);
        break;
      default:
    }
  });

  // Aperçu (portrait kimono et samouraï) : pas d'« Enregistrer l'image » par clic droit sur le design (appui long : style.css)
  teesEl.addEventListener('contextmenu', e => { if (e.target.closest('.pk__scene')) e.preventDefault(); });

  teesEl.addEventListener('input', e => {
    const input = e.target.closest('[data-act="name"]');
    if (!input) return;
    const k = +input.closest('.tb').dataset.tee;
    const a = +input.dataset.animal;
    state.tees[k].animals[a].name = input.value;
    if (DIRECT) { majPrenomPortrait(k); preparerPlusTard(k); }
    if (input.value.trim()) mesurer('nom_ecrit');
    if (input.value.trim()) input.classList.remove('has-error');
    refreshErrors(k);
    setActive(k, a);
  });

  teesEl.addEventListener('change', e => {
    const input = e.target.closest('[data-act="file"]');
    if (!input) return;
    const k = +input.closest('.tb').dataset.tee;
    addPhotos(k, +input.dataset.animal, input.files);
  });

  teesEl.addEventListener('focusin', e => {
    const field = e.target.closest('[data-animal]');
    const card = e.target.closest('.tb');
    if (card && field) setActive(+card.dataset.tee, +field.dataset.animal);
  });

  // Glisser-déposer une photo sur une zone
  ['dragenter', 'dragover'].forEach(ev => teesEl.addEventListener(ev, e => {
    const up = e.target.closest('.up');
    if (!up) return;
    e.preventDefault();
    up.classList.add('is-over');
  }));
  ['dragleave', 'drop'].forEach(ev => teesEl.addEventListener(ev, e => {
    const up = e.target.closest('.up');
    if (up) { e.preventDefault(); up.classList.remove('is-over'); }
  }));
  teesEl.addEventListener('drop', e => {
    const up = e.target.closest('.up');
    if (!up || !e.dataTransfer || !e.dataTransfer.files.length) return;
    addPhotos(+up.closest('.tb').dataset.tee, +up.dataset.up, e.dataTransfer.files);
  });

  function closePops() {
    $$('[data-pop]', teesEl).forEach(p => { p.hidden = true; });
    $$('.cpick.is-open', teesEl).forEach(b => { b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); });
  }
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-pop]') && !e.target.closest('[data-act="color-open"]')) closePops();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closePops(); });

  function addPhotos(k, a, fileList) {
    const animal = state.tees[k].animals[a];
    const files = [...fileList].filter(f => f.type.startsWith('image/') || /\.(heic|heif)$/i.test(f.name));
    if (!files.length) { toast(L.notImage); return; }
    mesurer('photo_ajoutee');
    const ok = files.filter(f => f.size <= 25 * 1024 * 1024);
    if (ok.length < files.length) toast(L.tooBig);
    const maxPhotos = DIRECT ? 1 : MAX_PHOTOS; // page portrait : une seule photo
    const room = maxPhotos - animal.photos.length;
    ok.slice(0, room).forEach(f => {
      const photo = { file: f, url: URL.createObjectURL(f) };
      garderEnMemoire(photo);
      animal.photos.push(photo);
      // Envoi tout de suite, en arrière-plan (comme avant) : au moment de l'ajout au panier, elle est déjà arrivée
      uploadPhoto(photo).then(() => renderUpload(k, a));
    });
    if (ok.length > room) toast(L.maxPhotos(maxPhotos));
    renderUpload(k, a);
    // Page portrait : la création démarre tout de suite, pendant que le client écrit le prénom et choisit la taille
    if (DIRECT && ok.length && room > 0 && state.tees[k].portrait.etat !== 'pret') creerPortrait(k);
    else if (DIRECT) renderPortrait(k);
    refreshErrors(k);
    setActive(k, a);
  }

  /* Envoi de chaque photo vers Cloudinary dès qu'elle est ajoutée, en arrière-plan, réduite à 2000 px.
     Notre serveur délivre une signature pour chaque envoi : sans elle, Cloudinary refuse le fichier.
     Les photos sont privées (dossier kizuna/commandes) et rattachées à la commande au paiement. */
  // Photo réduite à 2000 px (JPEG) ; format illisible par le navigateur (HEIC…) : le fichier d'origine
  async function photoPourEnvoi(file) {
    try {
      const img = await decoderImage(file);
      const s = Math.min(1, 2000 / Math.max(img.width, img.height));
      if (s === 1 && file.size < 1.5 * 1024 * 1024) return file;
      const c = document.createElement('canvas');
      c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      return (await new Promise(ok => c.toBlob(ok, 'image/jpeg', 0.86))) || file;
    } catch (e) { return file; }
  }
  // Image lue par le navigateur ; repli par une balise <img> (certains formats ne passent que par là)
  async function decoderImage(blob) {
    try { return await createImageBitmap(blob); } catch (e) {
      const url = URL.createObjectURL(blob);
      try { return await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = ko; i.src = url; }); } finally { setTimeout(() => URL.revokeObjectURL(url), 2000); }
    }
  }
  // Sur iPhone, le fichier choisi peut devenir illisible dès qu'on passe sur une autre appli (le système efface sa copie
  // temporaire) : on en garde tout de suite une copie en mémoire, réduite à 2000 px, qui sert ensuite à l'aperçu, au
  // panier et à l'envoi
  function garderEnMemoire(photo) {
    photo.pret = (async () => {
      try {
        const reduite = await photoPourEnvoi(photo.file);
        const copie = reduite !== photo.file ? reduite : new Blob([await photo.file.arrayBuffer()], { type: photo.file.type || 'image/jpeg' });
        photo.file = copie;
        photo.url = URL.createObjectURL(copie);
      } catch (e) { /* fichier déjà illisible : signalé à l'aperçu */ }
    })();
    return photo.pret;
  }
  const LOCAL = /^(localhost|127\.0\.0\.1|192\.168\.)/.test(location.hostname);
  function uploadPhoto(photo) {
    photo.status = 'uploading';
    photo.promise = (async () => {
      await photo.pret;
      // Jusqu'à 3 essais (réseau du téléphone qui flanche) avant d'abandonner
      for (let essai = 1; essai <= 3; essai++) {
        try {
          const fd = new FormData();
          fd.append('file', await photoPourEnvoi(photo.file), 'photo.jpg');
          fd.append('upload_preset', 'npp-uploads');
          const up = await fetch('https://api.cloudinary.com/v1_1/dvtyqvo5c/image/upload', { method: 'POST', body: fd });
          if (!up.ok) throw new Error('envoi');
          const envoi = await up.json();
          photo.publicId = envoi.public_id;
          photo.lien = envoi.secure_url;
          photo.status = 'done';
          return;
        } catch (err) {
          if (essai === 3) { photo.status = 'error'; return; }
          await new Promise(ok => setTimeout(ok, essai * 1500));
        }
      }
    })();
    return photo.promise;
  }

  // Galerie : la couleur du kimono est écrite sur chaque visuel, pour que le client sache quelle couleur il regarde
  $$('.minis__item[data-couleur]').forEach(b => {
    const c = colorById(b.dataset.couleur);
    if (!c) return;
    const s = document.createElement('span');
    s.className = 'minis__couleur';
    s.innerHTML = `<i style="--c:${c.hex}"></i>${esc(c.label)}`;
    b.appendChild(s);
  });

  $('#addTee').addEventListener('click', () => { if (state.qty < 3) setQty(state.qty + 1, true); });

  /* =========================================================
     VALIDATION
     ========================================================= */
  // Page portrait : le portrait doit être créé (c'est lui qui sera imprimé)
  const teeComplete = t => !!t.size && t.animals.slice(0, t.count).every(a => a.name.trim() && a.color && a.photos.length)
    && (!DIRECT || t.portrait.etat === 'pret');

  // Affiche les erreurs d'une carte ; renvoie le premier élément en erreur (ou null)
  function checkTee(k) {
    const card = $(`.tb[data-tee="${k}"]`, teesEl);
    const t = state.tees[k];
    const animals = t.animals.slice(0, t.count);
    const many = t.count > 1;
    const msg = (field, text) => { $(`[data-err="${field}"]`, card).textContent = text; };
    let first = null;
    card.classList.add('show-errors');

    const sizesBox = $('.tb__sizes', card);
    sizesBox.classList.toggle('has-error', !t.size);
    msg('size', t.size ? '' : L.errSize);
    if (!t.size) first = first || sizesBox;

    let missing = false;
    animals.forEach((an, a) => {
      const el = $(`[data-act="name"][data-animal="${a}"]`, card);
      const bad = !an.name.trim();
      el.classList.toggle('has-error', bad);
      if (bad) { missing = true; first = first || el; }
    });
    msg('name', missing ? (many ? L.errNameMany : L.errName) : '');

    missing = false;
    animals.forEach((an, a) => {
      const el = $(`[data-act="color-open"][data-animal="${a}"]`, card);
      el.classList.toggle('has-error', !an.color);
      if (!an.color) { missing = true; first = first || el; }
    });
    msg('color', missing ? (many ? L.errColorMany : L.errColor) : '');

    missing = false;
    animals.forEach((an, a) => {
      const el = $(`[data-up="${a}"]`, card);
      el.classList.toggle('has-error', !an.photos.length);
      if (!an.photos.length) { missing = true; first = first || el; }
    });
    msg('photo', missing ? (many ? L.errPhotoMany : L.errPhoto) : '');
    // Page portrait : photo bien là, mais portrait pas encore prêt (en cours de création, ou création ratée)
    if (DIRECT && !missing && t.portrait.etat !== 'pret') {
      msg('portrait', t.portrait.etat === 'creation' ? L.errPortrait : L.errPortraitRate);
      first = first || $('[data-pk]', card);
    }

    if (!first) card.classList.remove('show-errors');
    return first;
  }

  // Après une première tentative, les erreurs se mettent à jour en direct
  function refreshErrors(k) {
    const card = $(`.tb[data-tee="${k}"]`, teesEl);
    if (card && card.classList.contains('show-errors')) checkTee(k);
    renderProgress();
  }

  function validateAll() {
    let first = null;
    let firstTee = -1;
    for (let k = 0; k < state.qty; k++) {
      const f = checkTee(k);
      if (f && !first) { first = f; firstTee = k; }
    }
    if (!first) return true;
    if (state.qty > 1) toast(L.errTee(firstTee + 1));
    first.scrollIntoView({ behavior: smooth(), block: 'center' });
    if (first.tagName === 'INPUT') setTimeout(() => first.focus({ preventScroll: true }), 450);
    const btn = $('#addToCart');
    btn.classList.remove('is-shake'); void btn.offsetWidth; btn.classList.add('is-shake');
    return false;
  }

  const form = $('#configForm');
  form.addEventListener('submit', e => {
    e.preventDefault();
    if (!validateAll()) return;
    const tees = state.tees.slice(0, state.qty);
    // Ajout au panier IMMÉDIAT, sans aucune attente : une photo pas encore arrivée (ou dont l'envoi a échoué) continue
    // ou reprend en arrière-plan, pendant que le client regarde son panier ; le paiement attend la fin s'il le faut
    tees.forEach((t, k) => {
      const item = {
        id: Date.now() + k,
        count: t.count,
        size: t.size,
        surprise: !!t.surprise,
        animals: t.animals.slice(0, t.count).map(a => ({
          name: a.name.trim(),
          color: a.color,
          photos: a.photos.map(p => p.url),                       // aperçus locaux (affichage du panier)
          ids: a.photos.map(p => p.publicId).filter(Boolean),     // photos reçues sur Cloudinary (commande)
          liens: a.photos.map(p => p.lien).filter(Boolean)       // liens des photos (commande Shopify)
        }))
      };
      // Page portrait : le fichier imprimé (portrait + prénom, 2000 px) et la vignette du panier (le t-shirt avec le
      // portrait) sont préparés puis envoyés comme les photos
      let design = null, vignette = null;
      if (DIRECT) {
        item.portrait = true;
        if (SAMOURAI_DIRECT) item.animals[0].color = t.portrait.couleur; // la couleur du dessin créé
        ({ design, vignette } = preparerFichiers(t));
        // déjà prêts (cas normal) : la ligne Shopify part avec le portrait et la vignette, le tiroir les montre tout de suite
        if (design.lien) item.design = design.lien;
        if (vignette.lien) item.vignetteLien = vignette.lien;
        item.animals[0].photos = [vignette.url || t.portrait.url];
        if (vignette.url) item.animals[0].vignette = vignette.url;
        else vignette.pret.then(() => { item.animals[0].photos = [vignette.url]; item.animals[0].vignette = vignette.url; renderCart(); }).catch(() => {});
      }
      // Envoi (ou nouvel envoi) des photos de ce t-shirt, telles qu'au moment de l'ajout ; panier mis à jour ensuite
      const photosAjout = t.animals.slice(0, t.count).map(a => [...a.photos]);
      item.renvoyer = () => {
        const photos = photosAjout.flat().concat(design ? [design, vignette] : []);
        photos.filter(p => !p.publicId && p.status !== 'uploading' && p.status !== 'local').forEach(uploadPhoto);
        return Promise.all(photos.map(p => p.promise).filter(Boolean)).then(() => {
          item.animals.forEach((a, j) => { a.ids = photosAjout[j].map(p => p.publicId).filter(Boolean); a.liens = photosAjout[j].map(p => p.lien).filter(Boolean); });
          if (design) { item.design = design.lien || ''; item.vignetteLien = vignette.lien || ''; }
          sauverPanier();
        });
      };
      item.envoi = item.renvoyer();
      cart.push(item);
      // Vignettes préparées en arrière-plan, puis panier gardé avec elles
      if (!design) Promise.all(item.animals.map(async (a, j) => { a.vignette = await vignettePhoto(t.animals[j].photos[0]); })).then(sauverPanier);
    });
    sauverPanier();
    renderCart();
    openCart();
    mesurer('panier');
    suivre('AddToCart', { ...produitMeta(tees.length), value: Math.round(tees.reduce((s, t) => s + teeRegular(t), 0) * 100) / 100, currency: DEVISE });
  });

  /* =========================================================
     EXEMPLE DU T-SHIRT (ordinateur ; masqué sur mobile)
     Montre seulement un exemple dans la couleur de kimono choisie : ni le prénom ni la photo du client ne sont
     incrustés (le portrait est créé pour chaque commande et envoyé en aperçu par e-mail sous 24h).
     ========================================================= */
  const preview = $('#preview');
  const previewImg = $('#previewImg');
  const previewBadge = $('#previewBadge');

  // Visuels du t-shirt annotés « + Son prénom en japonais » : une version par langue (produit-4-en.webp…)
  const imageProduit = visuelCouleur;

  function setPreviewImage(n) {
    if (n === state.previewImg) return;
    state.previewImg = n;
    preview.classList.add('is-switching');
    setTimeout(() => {
      previewImg.src = imageProduit(n);
      previewImg.onload = () => preview.classList.remove('is-switching');
    }, 160);
  }

  // Couleur de kimono choisie : l'exemple change de couleur (et le badge indique le prénom de l'animal d'exemple)
  function updatePreview(switchToColor) {
    const t = state.tees[state.activeTee];
    const a = t.animals[Math.min(state.activeAnimal, t.count - 1)];
    const col = colorById(a.color);
    if (switchToColor && col && col.img) setPreviewImage(col.img);
    $('span', previewBadge).textContent = L.previewExample(PORTRAIT ? window.KZ.portraitNoms[(state.previewImg - 1) % window.KZ.portraitNoms.length] : colorByImg(state.previewImg).ex);
  }

  /* =========================================================
     PANIER (une ligne par t-shirt)
     ========================================================= */
  const cartEl = $('#cart');
  const cartBody = $('#cartBody');
  const cartFoot = $('#cartFoot');

  // Prix d'une ligne du panier ou du récapitulatif : « Offert » pour le t-shirt offert par l'offre ; sinon le prix
  // remisé (39,90 €) avec le prix normal barré, comme sur les pages produit (la somme des lignes = le total)
  const prixLigne = (it, k, offerts, classe) => {
    const normal = teeRegular(it), reduit = normal - remise(1);
    if (offerts.has(k)) return `<span class="${classe} is-offert"><span><s>${money(normal)}</s> <strong>${money(0)}</strong></span><small>${L.teeOffert}</small></span>`;
    return `<span class="${classe}">${reduit < normal ? `<s>${money(normal)}</s> ` : ''}<strong>${money(reduit)}</strong></span>`;
  };
  // Modèle tout fait : nom (traduit si c'est un mot français) et gamme
  const infosModele = it => {
    const m = modeleParId(it.ref) || { nom: it.ref, g: '' };
    return { nom: nomModele(m), gamme: (gammeParId(m.g) || { nom: '' }).nom };
  };

  // Panier de t-shirts de la boutique seulement (.is-boutique : pas d'aperçu, rétractation de 14 jours) ou mélangé
  // avec des personnalisés (.is-mixte) : le panier et le paiement montrent les bonnes étapes et la bonne case des CGV
  function marquerTypePanier(el, liste) {
    const modeles = liste.filter(estModele).length;
    el.classList.toggle('is-boutique', liste.length > 0 && modeles === liste.length);
    el.classList.toggle('is-mixte', modeles > 0 && modeles < liste.length);
  }

  function renderCart() {
    const n = cart.length;
    const { sousTotal: subtotal, remise: discount, total, offerts } = totauxPanier();
    marquerTypePanier(cartEl, cart);
    const badge = $('#cartCount');
    badge.textContent = n;
    badge.hidden = n === 0;
    $('#cartTitleCount').textContent = n ? `(${n})` : '';
    // Les lignes montrent déjà les prix remisés et « Offert » : en bas, seulement la livraison (la somme des lignes = le total)
    $('#cartLines').innerHTML = `
      <div class="drawer__line drawer__line--ship"><span>${L.shipping}</span><span>${L.free}</span></div>`;
    if (autresArticles) $('#cartLines').insertAdjacentHTML('afterbegin', autresListe.map(l => `<div class="drawer__line drawer__line--autres"><span>+ ${l.quantity} × ${esc(l.product_title)}</span><span>au paiement</span></div>`).join(''));
    $('#cartTotal').textContent = money(total);
    $('#cartOld').textContent = discount ? money(subtotal) : ''; // prix barré : total avant remise
    cartFoot.hidden = n === 0;
    renderBundle();

    if (!n) {
      cartBody.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty__ic">${ICON('i-paw')}</div>
          <p>${L.cartEmpty}</p>
          ${PAGE_BOUTIQUE
            ? `<a href="/collections/japon" class="btn btn--shu">${L.seeShop}</a>`
            : `<a href="#creer" class="btn btn--shu" data-close-cart>${L.createTee}</a>`}
        </div>`;
      return;
    }

    cartBody.innerHTML = jaugeHTML(n + autresArticles) + cart.map((it, k) => {
      if (estModele(it)) {
        const m = infosModele(it);
        return `
        <article class="item" data-id="${it.id}">
          ${vignettesTshirt(it, 'item__img')}
          <div>
            <h3 class="item__title">${L.modelTitle(esc(m.nom))}</h3>
            <p class="item__meta">${L.rangeOf(esc(m.gamme))} · ${L.sizeIs(it.size)}</p>
            <div class="item__row">
              <button type="button" class="item__remove" data-del>${L.remove}</button>
              ${prixLigne(it, k, offerts, 'item__price')}
            </div>
          </div>
        </article>`;
      }
      const lines = it.animals.map(a => {
        const c = colorById(a.color);
        if (c.id === 'portrait') return `<li><strong>${esc(a.name)}</strong></li>`; // portrait kimono : toujours le même kimono
        const dot = c.hex ? `<i style="--c:${c.hex}"></i>` : '<i class="dot-surprise"></i>';
        return `<li>${dot}<strong>${esc(a.name)}</strong> · ${c.hex ? L.kimono(c.label) : L.kimonoSurprise}</li>`;
      }).join('');
      return `
        <article class="item" data-id="${it.id}">
          ${vignettesTshirt(it, 'item__img')}
          <div>
            <h3 class="item__title">${L.itemTitle(n > 1 ? k + 1 : 0)}</h3>
            <ul class="item__animals">${lines}</ul>
            <p class="item__meta">${L.sizeIs(it.size)}${supplementTshirt(it)}${it.surprise ? ` · ${L.apercuSans}` : ''}</p>
            <div class="item__row">
              <button type="button" class="item__remove" data-del>${L.remove}</button>
              ${prixLigne(it, k, offerts, 'item__price')}
            </div>
          </div>
        </article>`;
    }).join('') + (offreActive() ? '' : upsellHTML(n)); // pendant la méga offre, la jauge du haut a les boutons
  }

  // Vignette d'un t-shirt du panier et de la commande : la photo envoyée par le client pour CHAQUE animal (jamais
  // un visuel d'exemple, qui laisserait croire que c'est l'animal imprimé). Plusieurs animaux : une carte par
  // animal, en éventail. Sans photo affichable (retour de paiement, format HEIC…) : une patte.
  // Modèle tout fait : sa photo produit.
  function vignettesTshirt(it, classe) {
    if (estModele(it)) {
      return `<div class="${classe} vignettes vignettes--1 vignettes--modele"><span class="vignette">${ICON('i-shirt')}<img src="https://kizunapaws.com/assets/img/boutique/${esc(it.ref)}-640.webp" alt="${esc(infosModele(it).nom)}" data-broken="hide"></span></div>`;
    }
    const cartes = it.animals.map(a => {
      const photo = (a.photos || [])[0];
      return `<span class="vignette">${ICON('i-paw')}${photo ? `<img src="${esc(photo)}" alt="${esc(a.name)}" data-broken="hide">` : ''}</span>`;
    });
    return `<div class="${classe} vignettes vignettes--${cartes.length}">${cartes.join('')}</div>`;
  }
  // « · 2 animaux +5 € » : supplément affiché à côté du nombre d'animaux
  const supplementTshirt = it => (it.count > 1 ? ` · ${L.animals(it.count)} <span class="supp">+${euros(G.supplements[it.count])}</span>` : '');

  // Méga offre : jauge en haut du panier, 3 cases (t-shirt, t-shirt, cadeau) qui se remplissent, et où en est le client
  // (« Ajoutez 2 t-shirts : le 3e vous est offert », « Plus qu'1 t-shirt… », « Bravo ! 1 t-shirt offert… »)
  function jaugeHTML(n) {
    if (!offreActive() || !n) return '';
    const reste = n % 3 ? 3 - (n % 3) : 0, pleines = 3 - reste;
    const cases = [0, 1, 2].map(i => `<span class="jauge__etape${i < pleines ? ' is-pleine' : ''}${i === 2 ? ' jauge__etape--offert' : ''}"><span class="jauge__case${i < pleines ? ' is-pleine' : ''}${i === 2 ? ' jauge__case--offert' : ''}">${ICON(i === 2 ? 'i-gift' : 'i-shirt')}</span><small>${L.jaugeEtapes[i]}</small></span>`).join('');
    return `
      <div class="jauge${reste ? '' : ' jauge--ok'}" role="status">
        <p class="jauge__regle">${L.jaugeRegle}</p>
        <div class="jauge__cases" style="--fil:${(pleines - 1) / 2}">${cases}</div>
        <p>${L.jauge(reste, Math.floor(n / 3))}</p>
        <div class="jauge__acts"${reste ? '' : ' hidden'}>
          <a href="/collections/japon" class="btn btn--ink btn--sm" data-upsell-boutique>${L.chooseInShop} ${ICON('i-arrow')}</a>
          <button type="button" class="btn btn--ghost btn--sm" data-new-tee>${L.createAnother}</button>
        </div>
      </div>`;
  }

  // Offre « 2 achetés = 1 offert » : le panier dit au client où il en est (2 t-shirts : le prochain est offert ;
  // 3 : un t-shirt offert ; sinon : ce que rapporte le suivant), avec la boutique et un autre t-shirt personnalisé
  function upsellHTML(n) {
    const actions = `
          <div class="cart-upsell__acts">
            <a href="/collections/japon" class="btn btn--ink btn--sm" data-upsell-boutique>${L.chooseInShop} ${ICON('i-arrow')}</a>
            <button type="button" class="btn btn--ghost btn--sm" data-new-tee>${L.createAnother}</button>
          </div>`;
    if (n % 3 === 0 && offreActive()) {
      return `
        <div class="cart-upsell cart-upsell--done">
          ${ICON('i-sparkle')}
          <div><p>${L.upsellDone(n / 3)}</p>${actions}</div>
        </div>`;
    }
    // Méga offre : « encore 2 et le 3e est offert », « votre 3e est offert » ; après l'offre : ce que rapporte le suivant
    const prochain = !offreActive() ? L.upsell(euros(remise(n + 1) - remise(n))) : n % 3 === 2 ? L.upsellFree : L.upsellDeux;
    return `
      <div class="cart-upsell${offreActive() && n % 3 === 2 ? ' cart-upsell--free' : ''}">
        ${ICON('i-gift')}
        <div><p>${prochain}</p>${actions}</div>
      </div>`;
  }

  cartBody.addEventListener('click', e => {
    if (e.target.closest('[data-upsell-boutique]')) { mesurer('panier_boutique'); return; }
    if (e.target.closest('[data-new-tee]')) {
      mesurer('panier_autre');
      // Pages de la boutique : le formulaire du t-shirt personnalisé est sur sa page
      if (PAGE_BOUTIQUE) { location.href = `${RACINE}t-shirt-samourai#creer`; return; }
      closeCart();
      resetConfig();
      $('#creer').scrollIntoView({ behavior: smooth() });
      return;
    }
    const art = e.target.closest('.item');
    if (art && e.target.closest('[data-del]')) {
      mesurer('panier_retire');
      cart.splice(cart.findIndex(x => x.id === +art.dataset.id), 1);
      sauverPanier();
      renderCart();
    }
  });

  // Repart d'un formulaire vierge pour créer un autre t-shirt
  function resetConfig() {
    state.tees = [newTee(), newTee(), newTee()];
    state.activeTee = 0;
    state.activeAnimal = 0;
    setQty(1);
  }

  let lastFocus = null;
  function openCart() {
    const ouvrir = () => {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      const d = document.getElementById('cart-drawer');
      if (d && typeof d.show === 'function') d.show();
      else { const a = document.querySelector('a[aria-controls="cart-drawer"]'); if (a) a.click(); }
    };
    setTimeout(() => synchro.then(ouvrir, ouvrir), 320);
    return;
    lastFocus = document.activeElement;
    cartEl.classList.add('is-open');
    cartEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    setTimeout(() => $('.drawer__head [data-close-cart]', cartEl).focus(), 50);
  }
  function closeCart() {
    cartEl.classList.remove('is-open');
    cartEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  $('#cartOpen').addEventListener('click', () => { renderCart(); openCart(); });
  // Panier refermé sans commander (croix, fond, Échap) : compté pour la mesure d'audience, s'il contient un t-shirt
  const fermerPanier = () => { if (cart.length) mesurer('panier_ferme'); closeCart(); };
  cartEl.addEventListener('click', e => { if (e.target.closest('[data-close-cart]')) fermerPanier(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && cartEl.classList.contains('is-open')) fermerPanier(); });

  /* ===== Menu plein écran (téléphone et tablette) ===== */
  const menu = $('#menu');
  const menuBtn = $('#menuOpen');
  function openMenu() {
    menu.hidden = false;
    menuBtn.setAttribute('aria-expanded', 'true');
    document.body.classList.add('no-scroll', 'menu-open');
    setTimeout(() => $('[data-menu-close]', menu).focus(), 50);
  }
  function closeMenu() {
    menu.hidden = true;
    menuBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('no-scroll', 'menu-open');
  }
  menuBtn.addEventListener('click', openMenu);
  // Un lien ferme le menu puis la page descend normalement jusqu'à la section
  menu.addEventListener('click', e => { if (e.target.closest('[data-menu-close], [data-menu-link]')) closeMenu(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !menu.hidden) { closeMenu(); menuBtn.focus(); } });

  /* =========================================================
     PAIEMENT : fenêtre plein écran par-dessus le site (maquette ;
     les champs de carte et les moyens de paiement seront ceux de Stripe, prix recalculé côté serveur)
     ========================================================= */
  const checkout = $('#checkout');
  const coForm = $('#coForm');

  function renderCheckout() {
    const n = cart.length;
    const { sousTotal: subtotal, remise: discount, total, offerts } = totauxPanier();
    const label = L.tees(n);
    marquerTypePanier(checkout, cart);
    $('#coItems').innerHTML = cart.map((it, k) => {
      const info = estModele(it)
        ? (m => `<p class="co-item__title">${L.modelTitle(esc(m.nom))}</p>
          <p class="co-item__meta">${L.rangeOf(esc(m.gamme))} · ${L.sizeIs(it.size)}</p>`)(infosModele(it))
        : `<p class="co-item__title">${L.coItemTitle}</p>
          <ul>${it.animals.map(a => {
            const c = colorById(a.color);
            return `<li><i class="${c.hex ? '' : 'is-surprise'}" style="${c.hex ? `background:${c.hex}` : ''}"></i><span><strong>${esc(a.name)}</strong> · ${c.hex ? L.kimono(c.label) : L.kimonoSurprise}</span></li>`;
          }).join('')}</ul>
          <p class="co-item__meta">${L.sizeIs(it.size)}${supplementTshirt(it)}${it.surprise ? ` · ${L.apercuSans}` : ''}</p>`;
      return `
      <article class="co-item">
        <div class="co-item__img">${vignettesTshirt(it, 'co-item__thumbs')}<span>${k + 1}</span></div>
        <div class="co-item__info">${info}</div>
        ${prixLigne(it, k, offerts, 'co-item__price')}
      </article>`;
    }).join('');
    // Comme le panier : les lignes sont déjà au prix remisé et « Offert » ; en dessous, la livraison et le total
    $('#coTotals').innerHTML = `
      <div><dt>${L.shipping}</dt><dd class="co-totals__free">${L.free}</dd></div>
      <div class="co-totals__total"><dt>${L.totalTtc}</dt><dd><s class="prix-barre">${money(subtotal)}</s> ${money(total)}</dd></div>`;
    $('#coSummaryLabel').textContent = L.yourOrder(label);
    $('#coSummaryTotal').textContent = money(total);
    $('#coEta').textContent = L.etaLabel($('#etaShip').textContent);
    $('#coPayLabel').textContent = L.pay(money(total));
  }

  /* ----- Stripe : moyens de paiement intégrés à notre fenêtre, à nos couleurs -----
     Le paiement est préparé par notre serveur (/api/boutique/paiement), qui recalcule le prix. */
  const centimes = () => Math.round(totauxPanier().total * 100);
  const STRIPE_LOOK = {
    theme: 'stripe',
    variables: {
      colorPrimary: '#C0627A', colorBackground: '#FFFFFF', colorText: '#2A2326', colorTextSecondary: '#6E6468',
      colorDanger: '#B3405C', fontFamily: 'Manrope, system-ui, sans-serif', fontSizeBase: '15px',
      borderRadius: '13px', spacingUnit: '4px'
    },
    rules: {
      '.AccordionItem': { borderColor: 'rgba(42, 35, 38, .14)', boxShadow: 'none' },
      '.Input': { borderColor: 'rgba(42, 35, 38, .18)', boxShadow: 'none' },
      '.Input:focus': { borderColor: '#C0627A', boxShadow: '0 0 0 3px rgba(192, 98, 122, .15)' }
    }
  };
  let stripe = null;
  let stripeElements = null;
  function loadStripe() {
    if (window.Stripe) return Promise.resolve(window.Stripe);
    return new Promise((ok, ko) => {
      const s = document.createElement('script');
      s.src = 'https://js.stripe.com/v3/';
      s.onload = () => ok(window.Stripe);
      s.onerror = ko;
      document.head.append(s);
    });
  }
  async function mountPayment() {
    if (stripeElements) { stripeElements.update({ amount: centimes(), currency: DEVISE.toLowerCase() }); return; }
    try {
      const StripeJs = await loadStripe();
      stripe = StripeJs(CONFIG.stripe, { locale: L.stripe });
      stripeElements = stripe.elements({
        mode: 'payment', amount: centimes(), currency: DEVISE.toLowerCase(), appearance: STRIPE_LOOK,
        fonts: [{ cssSrc: 'https://fonts.googleapis.com/css2?family=Manrope:wght@500;600;700&display=swap' }]
      });
      const paymentEl = stripeElements.create('payment', {
        layout: { type: 'accordion', defaultCollapsed: false, radios: true, spacedAccordionItems: false },
        // Carte bancaire en premier, donc sélectionnée par défaut (sinon Stripe choisit l'ordre, parfois PayPal)
        paymentMethodOrder: ['card', 'apple_pay', 'google_pay', 'paypal'],
        // Nom, e-mail et adresse sont déjà demandés plus haut : Stripe ne les redemande pas
        fields: { billingDetails: { name: 'never', email: 'never', address: 'never' } }
      });
      $('#paymentElement').innerHTML = '';
      paymentEl.mount('#paymentElement');
    } catch (err) {
      $('#paymentElement').innerHTML = `<p class="co-payment__loading">${L.payLoadError}</p>`;
    }
  }

  async function openCheckout() {
    if (!cart.length) return;
    // Boutique Shopify : caisse Shopify (le panier Shopify est déjà à jour)
    $('#checkoutBtn').classList.add('is-busy');
    // 28/10 : photos déjà envoyées (cas normal : l'envoi part dès que la photo est choisie) → paiement IMMÉDIAT, sans attente
    if (cart.every(it => !it.animals || (it.animals.every(a => a.liens && a.liens.length) && (!it.portrait || it.design)))) {
      try { await synchro; } catch (e) { /* on tente quand même */ }
      location.href = '/checkout';
      return;
    }
    // photo encore en cours d'envoi : retour immédiat pendant l'attente (28/10) : voile plein écran « Préparation de votre commande… » posé sur la page (il reste
    // affiché même quand le panier de la boutique se redessine), retiré si le client revient en arrière depuis le paiement
    if (!document.getElementById('kz-attente-style')) {
      document.head.insertAdjacentHTML('beforeend', '<style id="kz-attente-style">.kz-attente-voile{position:fixed;inset:0;z-index:2147483000;display:grid;place-content:center;justify-items:center;gap:14px;padding:24px;background:rgba(250,246,240,.9);font:600 16px/1.35 Manrope,system-ui,sans-serif;color:#2A2326;text-align:center}.kz-attente-voile p{margin:0}.kz-attente-voile span{width:36px;height:36px;border:3px solid rgba(192,98,122,.25);border-top-color:#C0627A;border-radius:50%;animation:kzAttente .8s linear infinite}@keyframes kzAttente{to{transform:rotate(360deg)}}</style>');
      window.addEventListener('pageshow', e => { if (e.persisted) document.querySelectorAll('.kz-attente-voile').forEach(v => v.remove()); });
    }
    document.querySelectorAll('.kz-attente-voile').forEach(v => v.remove());
    document.body.insertAdjacentHTML('beforeend', '<div class="kz-attente-voile" role="status"><span aria-hidden="true"></span><p>Envoi de votre photo…</p></div>');
    // Photos et design encore en cours d'envoi (ajout au panier tout récent) : on attend (10 s au plus), un échec est relancé une fois
    const attendre = ps => Promise.race([Promise.all(ps), new Promise(ok => setTimeout(ok, 10000))]);
    await attendre(cart.map(it => it.envoi).filter(Boolean));
    const aRefaire = cart.filter(it => it.renvoyer && (it.animals.some(a => !a.liens || !a.liens.length) || (it.portrait && !it.design)));
    if (aRefaire.length) await attendre(aRefaire.map(it => (it.envoi = it.renvoyer())));
    sauverPanier();
    await new Promise(r => setTimeout(r, 300));
    try { await synchro; } catch (e) { /* on tente quand même */ }
    location.href = '/checkout';
    return;
    renderCheckout();
    closeCart();
    showDone(false);
    checkout.hidden = false;
    checkout.scrollTop = 0;
    document.body.classList.add('no-scroll', 'checkout-open');
    $('#coSummary').open = window.matchMedia('(min-width: 961px)').matches;
    setTimeout(() => $('[data-close-checkout]', checkout).focus(), 60);
    mountPayment();
    mesurer('commande');
    suivre('InitiateCheckout', { ...produitMeta(cart.length), value: centimes() / 100, currency: DEVISE });
  }
  function closeCheckout() {
    if ($('#coDone').hidden) mesurer('commande_fermee');
    checkout.hidden = true;
    document.body.classList.remove('no-scroll', 'checkout-open');
  }

  // Écran « Commande confirmée » (dans la même fenêtre)
  function showDone(on, info = {}) {
    $('.co-side', checkout).hidden = on;
    coForm.hidden = on;
    $('#coTitle').hidden = on;
    $('#coDone').hidden = !on;
    if (!on) return;
    // « alvin » ou « jean-pierre » saisis en minuscules → « Alvin », « Jean-Pierre »
    const prenom = (info.prenom || '').trim().replace(/(^|[\s-])(\p{Ll})/gu, (m, sep, l) => sep + l.toUpperCase());
    $('#coDoneName').textContent = prenom ? ` ${prenom}` : '';
    $('#coDoneEmail').textContent = info.email || L.emailFallback;
    $('#coDoneRef').textContent = info.ref ? `KP-${info.ref.slice(-8).toUpperCase()}` : '—';
    checkout.scrollTop = 0;
  }
  function orderPaid(info) {
    // Achat : même identifiant (n° du paiement Stripe) que l'envoi du serveur, pour que Meta ne le compte qu'une fois
    if (info.ref && info.montant) suivre('Purchase', { ...produitMeta(info.nb || 1), value: info.montant / 100, currency: info.devise }, info.ref);
    mesurer('achat');
    cart.length = 0;
    sauverPanier(); // panier vide : plus rien de gardé dans le navigateur
    renderCart();
    resetConfig();
    try { sessionStorage.removeItem('kizuna-panier'); } catch (err) { /* rien */ }
    if (checkout.hidden) {
      checkout.hidden = false;
      document.body.classList.add('no-scroll', 'checkout-open');
    }
    showDone(true, info);
  }
  function setPaying(on) {
    const btn = $('#coPay');
    btn.disabled = on;
    btn.classList.toggle('is-busy', on);
    $('#coPayLabel').textContent = on ? L.paying : L.pay(money(centimes() / 100));
  }
  $('#checkoutBtn').addEventListener('click', openCheckout);
  document.addEventListener('submit', e => {
    const f = e.target.closest && e.target.closest('cart-drawer form');
    if (!f || !cart.length) return;
    e.preventDefault(); e.stopPropagation();
    openCheckout();
  }, true);
  checkout.addEventListener('click', e => { if (e.target.closest('[data-close-checkout]')) closeCheckout(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && !checkout.hidden) closeCheckout(); });
  window.matchMedia('(min-width: 961px)').addEventListener('change', ev => { if (ev.matches) $('#coSummary').open = true; });

  // Pays de livraison : France, Union européenne, Suisse, États-Unis, Canada, Australie (Royaume-Uni suspendu)
  // (liste vérifiée aussi par le serveur, netlify/lib/pays.mjs). Noms des pays dans la langue de la page.
  const paysChoisi = () => coForm.elements.pays.value;
  const nomPays = (() => {
    let dn = null;
    try { dn = new Intl.DisplayNames([L.lang], { type: 'region' }); } catch (e) { /* navigateur ancien */ }
    return code => (dn && dn.of(code)) || code;
  })();
  (function remplirPays() {
    const tri = codes => codes.map(c => [c, nomPays(c)]).sort((a, b) => a[1].localeCompare(b[1], L.lang));
    const groupe = (label, codes) => `<optgroup label="${esc(label)}">${tri(codes).map(([c, n]) => `<option value="${c}">${esc(n)}</option>`).join('')}</optgroup>`;
    coForm.elements.pays.innerHTML = groupe(L.groupEurope, [...PAYS_UE, 'CH']) + groupe(L.groupAmerica, ['US', 'CA']) + groupe(L.groupOceania, ['AU']);
  })();
  // États (États-Unis, Australie) et provinces (Canada), demandés par les transporteurs
  const REGIONS = {
    US: { AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware',
      DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa',
      KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan', MN: 'Minnesota',
      MS: 'Mississippi', MO: 'Missouri', MT: 'Montana', NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico',
      NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island',
      SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington',
      WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming' },
    CA: { AB: 'Alberta', BC: 'British Columbia', MB: 'Manitoba', NB: 'New Brunswick', NL: 'Newfoundland and Labrador', NS: 'Nova Scotia',
      NT: 'Northwest Territories', NU: 'Nunavut', ON: 'Ontario', PE: 'Prince Edward Island', QC: 'Québec', SK: 'Saskatchewan', YT: 'Yukon' },
    AU: { ACT: 'Australian Capital Territory', NSW: 'New South Wales', NT: 'Northern Territory', QLD: 'Queensland', SA: 'South Australia',
      TAS: 'Tasmania', VIC: 'Victoria', WA: 'Western Australia' }
  };
  const CP_NUMERIQUE = ['FR', 'DE', 'AT', 'BE', 'BG', 'CY', 'HR', 'DK', 'ES', 'EE', 'FI', 'GR', 'HU', 'IT', 'LT', 'LU', 'PL', 'PT', 'CZ', 'RO', 'SK', 'SI', 'SE', 'US', 'CH', 'AU'];
  function cpValide(pays, cp) {
    if (pays === 'FR') return /^\d{5}$/.test(cp) || L.cpFR;
    if (pays === 'US') return /^\d{5}(-\d{4})?$/.test(cp) || L.cpUS;
    if (pays === 'CH' || pays === 'AU') return /^\d{4}$/.test(cp) || L.cp4;
    if (pays === 'GB') return /^[A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}$/i.test(cp) || L.cpBad;
    if (pays === 'CA') return /^[A-Z]\d[A-Z] ?\d[A-Z]\d$/i.test(cp) || L.cpBad;
    return /^[A-Za-z0-9][A-Za-z0-9 -]{1,8}[A-Za-z0-9]$/.test(cp) || L.cpBad;
  }
  let regionsDe = '';
  function majPays() {
    const pays = paysChoisi();
    const regions = REGIONS[pays];
    $('#coEtat').hidden = !regions;
    if (regions && regionsDe !== pays) {
      regionsDe = pays;
      $('#coEtat .co-label').textContent = L.stateLabel[pays];
      coForm.elements.etat.innerHTML = `<option value="">${esc(L.statePh[pays])}</option>` +
        Object.entries(regions).map(([c, n]) => `<option value="${c}">${esc(n)}</option>`).join('');
      $('[data-err="etat"]', coForm).textContent = '';
      coForm.elements.etat.classList.remove('has-error');
    }
    coForm.elements.cp.inputMode = CP_NUMERIQUE.includes(pays) ? 'numeric' : 'text';
    coForm.elements.complement.placeholder = pays === 'FR' ? L.complFR : L.compl;
  }
  // Pays pré-sélectionné : celui du visiteur s'il est livré, sinon celui de la langue de la page
  function paysParDefaut() {
    coForm.elements.pays.value = PAYS_LIVRES.includes(PAYS) ? PAYS : PAYS_PAR_LANGUE[L.lang];
    majPays();
  }
  paysParDefaut();
  coForm.elements.pays.addEventListener('change', () => {
    majPays();
    const cp = coForm.elements.cp;
    if (cp.classList.contains('has-error') || cp.value) { const r = cpValide(paysChoisi(), cp.value.trim()); $('[data-err="cp"]', coForm).textContent = r === true ? '' : r; cp.classList.toggle('has-error', r !== true); }
  });

  // Vérification du formulaire (avant d'appeler Stripe)
  const CO_RULES = {
    email: v => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) || L.errEmail,
    prenom: v => !!v || L.errFirst,
    nom: v => !!v || L.errLast,
    adresse: v => !!v || L.errAddress,
    cp: v => cpValide(paysChoisi(), v),
    ville: v => !!v || L.errCity,
    etat: v => !REGIONS[paysChoisi()] || !!v || L.stateErr[paysChoisi()]
  };
  function checkCheckout() {
    let first = null;
    Object.entries(CO_RULES).forEach(([name, rule]) => {
      const input = coForm.elements[name];
      const res = rule(input.value.trim());
      const msg = res === true ? '' : res;
      $(`[data-err="${name}"]`, coForm).textContent = msg;
      input.classList.toggle('has-error', !!msg);
      if (msg && !first) first = input;
    });
    const cgv = coForm.elements.cgv;
    $('[data-err="cgv"]', coForm).textContent = cgv.checked ? '' : L.errCgv;
    if (!cgv.checked && !first) first = cgv;
    return first;
  }
  coForm.addEventListener('submit', async e => {
    e.preventDefault();
    const payError = $('#coPayError');
    payError.textContent = '';
    const first = checkCheckout();
    if (first) { first.focus({ preventScroll: true }); first.scrollIntoView({ behavior: smooth(), block: 'center' }); return; }
    if (!stripe || !stripeElements) { payError.textContent = L.payLoading; return; }

    setPaying(true);
    // 1. Stripe vérifie les champs de paiement (carte incomplète, etc.) et affiche lui-même les erreurs
    const { error: submitError } = await stripeElements.submit();
    if (submitError) { setPaying(false); return; }

    // Photos encore en cours d'envoi (ajout au panier tout récent) : on attend la fin (30 s au plus) ;
    // un envoi qui a échoué est relancé une fois. Sans les photos, la commande ne peut pas partir.
    const attendre = ps => Promise.race([Promise.all(ps), new Promise(ok => setTimeout(ok, 30000))]);
    const sansPhotos = it => !estModele(it) && it.animals.some(a => !a.ids || !a.ids.length);
    await attendre(cart.map(it => it.envoi).filter(Boolean));
    const aRefaire = cart.filter(it => it.renvoyer && sansPhotos(it));
    if (aRefaire.length) await attendre(aRefaire.map(it => (it.envoi = it.renvoyer())));
    if (cart.some(sansPhotos)) { payError.textContent = L.netError; setPaying(false); return; }

    // 2. Notre serveur vérifie la commande, recalcule le prix et prépare le paiement
    const f = coForm.elements;
    const client = {
      email: f.email.value.trim(), prenom: f.prenom.value.trim(), nom: f.nom.value.trim(), adresse: f.adresse.value.trim(),
      complement: f.complement.value.trim(), cp: f.cp.value.trim().toUpperCase(), ville: f.ville.value.trim(), tel: f.tel.value.trim(),
      pays: f.pays.value, etat: REGIONS[f.pays.value] ? f.etat.value : ''
    };
    let data;
    try {
      const res = await fetch('/api/boutique/paiement', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Langue': L.lang },
        body: JSON.stringify({
          items: cart.map(it => (estModele(it) ? { type: 'modele', ref: it.ref, size: it.size }
            : { size: it.size, count: it.count, surprise: !!it.surprise, animals: it.animals.map(a => ({ name: a.name, color: a.color, photos: a.ids })) })),
          client, devise: DEVISE, langue: L.lang,
          // Accord pour la mesure des publicités : sans lui, rien n'est envoyé à Meta par le serveur
          pub: mesureAutorisee(), page: location.origin + location.pathname
        })
      });
      data = await res.json().catch(() => ({}));
      if (!res.ok || !data.clientSecret) throw new Error(data.error || L.payPrepError);
      mesurer('paiement');
    } catch (err) {
      payError.textContent = err.message || L.netError;
      setPaying(false);
      return;
    }

    // Panier gardé de côté : utile si le client part valider chez PayPal ou sa banque puis revient
    try {
      sessionStorage.setItem('kizuna-panier', JSON.stringify({
        cart: cart.map(it => (estModele(it) ? it
          : { ...it, envoi: undefined, renvoyer: undefined, animals: it.animals.map(a => ({ name: a.name, color: a.color, ids: a.ids, photos: [] })) })),
        client: { prenom: client.prenom, email: client.email },
        achat: { montant: data.montant, devise: data.devise, nb: cart.length }
      }));
    } catch (err) { /* navigation privée : sans conséquence */ }

    // 3. Paiement confirmé chez Stripe (3D Secure ou PayPal s'ouvrent si besoin)
    const fullName = `${client.prenom} ${client.nom}`;
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements: stripeElements,
      clientSecret: data.clientSecret,
      redirect: 'if_required',
      confirmParams: {
        return_url: `${location.origin}${location.pathname}?paiement=retour`,
        payment_method_data: {
          billing_details: {
            name: fullName, email: client.email, phone: client.tel || null,
            address: { line1: client.adresse, line2: client.complement || '', postal_code: client.cp, city: client.ville, state: client.etat, country: client.pays }
          }
        }
      }
    });
    if (error) { payError.textContent = error.message || L.payRefused; setPaying(false); return; }
    if (paymentIntent && ['succeeded', 'processing'].includes(paymentIntent.status)) {
      setPaying(false);
      orderPaid({ prenom: client.prenom, email: client.email, ref: paymentIntent.id, montant: data.montant, devise: data.devise, nb: cart.length });
    } else {
      payError.textContent = L.payFailed;
      setPaying(false);
    }
  });

  // Retour sur le site après une validation externe (PayPal, banque…)
  (function paymentReturn() {
    const q = new URLSearchParams(location.search);
    if (q.get('paiement') !== 'retour') return;
    const status = q.get('redirect_status');
    const ref = q.get('payment_intent') || '';
    history.replaceState(null, '', location.pathname + location.hash);
    let saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('kizuna-panier')); } catch (err) { saved = null; }
    if (status === 'succeeded' || status === 'processing') {
      if (saved && Array.isArray(saved.cart)) marquerTypePanier(checkout, saved.cart); // étapes de l'écran de confirmation
      orderPaid({ prenom: saved && saved.client.prenom, email: saved && saved.client.email, ref, ...((saved && saved.achat) || {}) });
    } else if (restaurerPanier() || (saved && saved.cart && saved.cart.length)) {
      // Panier gardé dans le navigateur (avec ses vignettes), sinon la copie faite avant le paiement
      if (!cart.length) { cart.push(...saved.cart); sauverPanier(); }
      renderCart();
      openCart();
      toast(L.payReturnFailed);
    }
  })();

  // Retour depuis l'e-mail de relance d'un panier abandonné (?reprise=jeton) : le serveur rend le panier et les
  // coordonnées saisies (jamais la carte bancaire), puis le paiement s'ouvre, déjà rempli
  async function reprendreCommande(jeton) {
    try {
      const res = await fetch(`/api/boutique/reprise?jeton=${encodeURIComponent(jeton)}`, { headers: { 'X-Langue': L.lang }, cache: 'no-store' });
      const d = await res.json().catch(() => ({}));
      if (d.deja) { toast(L.repriseDeja); return; }
      if (!res.ok || !Array.isArray(d.items) || !d.items.length) { toast(d.expire ? L.repriseExpiree : L.netError); return; }
      cart.length = 0;
      cart.push(...d.items.map((it, k) => (it.type === 'modele' ? { id: Date.now() + k, type: 'modele', ref: it.ref, size: it.size } : {
        id: Date.now() + k, count: it.count, size: it.size,
        animals: it.animals.map(a => ({ name: a.name, color: a.color, ids: a.ids, vignette: a.vignette, photos: a.vignette ? [a.vignette] : [] }))
      })));
      sauverPanier();
      renderCart();
      openCheckout();
      const f = coForm.elements, c = d.client || {};
      if (c.pays && [...f.pays.options].some(o => o.value === c.pays)) { f.pays.value = c.pays; f.pays.dataset.touche = '1'; majPays(); }
      ['email', 'prenom', 'nom', 'adresse', 'complement', 'cp', 'ville', 'tel'].forEach(k => { if (c[k] && f[k]) f[k].value = c[k]; });
      if (c.etat && f.etat) f.etat.value = c.etat;
      toast(`${ICON('i-paw')} ${L.repriseOk}`);
    } catch (e) { toast(L.netError); }
  }
  coForm.addEventListener('input', e => {
    const name = e.target.name;
    if (CO_RULES[name] && e.target.classList.contains('has-error') && CO_RULES[name](e.target.value.trim()) === true) {
      e.target.classList.remove('has-error');
      $(`[data-err="${name}"]`, coForm).textContent = '';
    }
    if (name === 'cgv' && e.target.checked) $('[data-err="cgv"]', coForm).textContent = '';
  });

  /* =========================================================
     DATE DE LIVRAISON ESTIMÉE
     ========================================================= */
  function addBusinessDays(date, n) {
    const d = new Date(date);
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }
  function renderEta() {
    // Français : « ven 9 oct », sans points ; autres langues : format habituel du pays
    const sansPoints = s => (L.lang === 'fr' ? s.replace(/\./g, '') : s);
    const fmt = d => sansPoints(d.toLocaleDateString(localeDates(), { weekday: 'short', day: 'numeric', month: 'short' }));
    // Aperçu : toujours 24h après la commande, week-end compris.
    const mock = new Date();
    if (!DIRECT) mock.setDate(mock.getDate() + 1); // page portrait : pas d'aperçu à attendre
    // Impression + expédition : en jours ouvrés, à partir de l'aperçu.
    const min = addBusinessDays(mock, CONFIG.joursEstimes[0]);
    const max = addBusinessDays(mock, CONFIG.joursEstimes[1]);
    // Fourchette courte pour tenir sur une ligne : « 8 – 13 oct » ou « 30 oct – 4 nov »
    const dm = d => sansPoints(d.toLocaleDateString(localeDates(), { day: 'numeric', month: 'short' }));
    const apercu = fmt(mock);
    const reception = L.lang !== 'fr' && Intl.DateTimeFormat.prototype.formatRange
      ? new Intl.DateTimeFormat(localeDates(), { day: 'numeric', month: 'short' }).formatRange(min, max)
      : min.getMonth() === max.getMonth() ? `${min.getDate()} – ${dm(max)}` : `${dm(min)} – ${dm(max)}`;
    if (!DIRECT) $('#etaMock').textContent = apercu;
    $('#etaShip').textContent = DIRECT ? L.pkLivraison : reception; // page portrait : « 3 à 5 jours »
    // Même frise, en petit, dans le panier
    if (!DIRECT) document.querySelectorAll('[data-eta="mock"]').forEach(e => { e.textContent = apercu; });
    document.querySelectorAll('[data-eta="ship"]').forEach(e => { e.textContent = reception; });
  }

  /* =========================================================
     GUIDE DES TAILLES (boutons présents partout, y compris dans les cartes)
     ========================================================= */
  const sizeGuide = $('#sizeGuide');
  const photoTips = $('#photoTips');
  const zoomDialog = $('#zoomDialog');
  const openDialog = d => { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); };

  // Agrandissement : une image, ou plusieurs (photos d'un avis, « data-zoom-set ») avec flèches, compteur et balayage
  const zoomImg = $('#zoomImg');
  let zoomSet = [];
  let zoomAt = 0;
  let zoomAlt = '';
  let zoomVignette = null;   // petite image déjà affichée dans la page, montrée en attendant la grande
  let zoomJeton = 0;
  // Grandes photos : téléchargées à l'avance (dès qu'on touche la vignette), une seule fois
  const zoomPretes = new Set();
  const zoomCharge = {};
  const precharger = u => zoomCharge[u] || (zoomCharge[u] = new Promise(res => {
    const im = new Image();
    im.onload = () => { zoomPretes.add(u); res(); };
    im.onerror = res;
    im.src = u;
  }));
  const listeZoom = z => (z.dataset.zoomSet || z.dataset.zoom).split(' ').filter(Boolean);
  function showZoom(i) {
    const n = zoomSet.length;
    zoomAt = (i + n) % n;
    const grand = zoomSet[zoomAt];
    const jeton = ++zoomJeton;
    zoomImg.alt = n > 1 ? L.photoOf(zoomAlt, zoomAt + 1, n) : zoomAlt;
    $('#zoomCount').textContent = `${zoomAt + 1} / ${n}`;
    zoomSet.forEach(precharger);
    if (zoomPretes.has(grand)) { zoomDialog.classList.remove('is-loading'); zoomImg.src = grand; return; }
    // En attendant : la vignette de la carte (déjà chargée), sinon un fond vide, jamais la photo précédente
    if (zoomAt === 0 && zoomVignette) { zoomImg.src = zoomVignette; zoomDialog.classList.remove('is-loading'); }
    else { zoomImg.removeAttribute('src'); zoomDialog.classList.add('is-loading'); }
    precharger(grand).then(() => {
      if (jeton !== zoomJeton) return;
      zoomImg.src = grand;
      zoomDialog.classList.remove('is-loading');
    });
  }
  document.addEventListener('pointerdown', e => {
    const z = e.target.closest('[data-zoom]');
    if (z) listeZoom(z).forEach(precharger);
  }, { passive: true });
  document.addEventListener('click', e => {
    if (e.target.closest('[data-open-size]')) openDialog(sizeGuide);
    if (e.target.closest('[data-open-tips]')) openDialog(photoTips);
    const z = e.target.closest('[data-zoom]');
    if (z) {
      const vignette = $('img', z);
      zoomSet = listeZoom(z);
      zoomAlt = vignette.alt;
      zoomVignette = vignette.complete && vignette.naturalWidth ? vignette.currentSrc : null;
      zoomDialog.classList.toggle('is-multi', zoomSet.length > 1);
      showZoom(0);
      openDialog(zoomDialog);
    }
  });
  [sizeGuide, photoTips, zoomDialog].forEach(d => d.addEventListener('click', e => {
    if (e.target === d || e.target.closest('[data-close-modal]')) d.close();
  }));
  zoomDialog.addEventListener('click', e => {
    const step = e.target.closest('[data-zoom-step]');
    if (step) showZoom(zoomAt + +step.dataset.zoomStep);
  });
  zoomDialog.addEventListener('keydown', e => {
    if (zoomSet.length < 2) return;
    if (e.key === 'ArrowLeft') showZoom(zoomAt - 1);
    if (e.key === 'ArrowRight') showZoom(zoomAt + 1);
  });
  // Balayage au doigt sur la photo (mobile)
  let zoomX = null;
  zoomImg.addEventListener('touchstart', e => { zoomX = e.touches[0].clientX; }, { passive: true });
  zoomImg.addEventListener('touchend', e => {
    if (zoomX === null || zoomSet.length < 2) return;
    const dx = e.changedTouches[0].clientX - zoomX;
    zoomX = null;
    if (Math.abs(dx) > 40) showZoom(zoomAt + (dx < 0 ? 1 : -1));
  }, { passive: true });

  /* =========================================================
     MINI CARROUSEL DE CRÉATIONS (défile tout seul, pause dès qu'on le touche)
     ========================================================= */
  const minis = $('#minis');
  let minisPauseUntil = 0;
  ['pointerdown', 'touchstart', 'wheel'].forEach(ev => minis.addEventListener(ev, () => { minisPauseUntil = Date.now() + 6000; }, { passive: true }));
  // Page produit sur téléphone : pas de défilement automatique (demande du propriétaire), on fait glisser soi-même
  const minisManuel = () => true && !window.matchMedia('(min-width: 961px)').matches;
  if (!reduceMotion) setInterval(() => {
    if (Date.now() < minisPauseUntil || document.hidden || minisManuel()) return;
    const r = minis.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    const step = ([...minis.children].find(x => x.offsetWidth) || minis.firstElementChild).offsetWidth + 10; // 1re image affichée
    if (minis.scrollLeft + minis.clientWidth >= minis.scrollWidth - 4) minis.scrollTo({ left: 0, behavior: 'smooth' });
    else minis.scrollBy({ left: step, behavior: 'smooth' });
  }, 2600);

  // Page produit sur ordinateur : la galerie de photos passe en grand à gauche, à la place de l'exemple de t-shirt
  // (les visuels du t-shirt se voient au choix de la couleur) ; elle revient dans le formulaire sur téléphone
  const galerie = $('.minis');
  const galerieAncre = galerie.nextElementSibling;
  const colonneGauche = $('.config__media');
  const ecranLarge = window.matchMedia('(min-width: 961px)');
  function placerGalerie() {
    const aGauche = true && ecranLarge.matches;
    if (aGauche && galerie.parentElement !== colonneGauche) colonneGauche.prepend(galerie);
    else if (!aGauche && galerie.parentElement === colonneGauche) galerieAncre.before(galerie);
    colonneGauche.classList.toggle('has-galerie', aGauche);
  }
  placerGalerie();
  ecranLarge.addEventListener('change', placerGalerie);
  galerie.addEventListener('click', e => {
    const f = e.target.closest('[data-minis]');
    if (!f) return;
    minisPauseUntil = Date.now() + 6000;
    // On vise directement la photo voulue (un scrollBy vers la gauche est ignoré avec l'aimantation des photos)
    const pas = minis.clientWidth + 10;
    const nb = [...minis.children].filter(x => x.offsetWidth).length;
    const i = (Math.round(minis.scrollLeft / pas) + +f.dataset.minis + nb) % nb; // en boucle
    minis.scrollTo({ left: i * pas, behavior: smooth() });
  });

  /* =========================================================
     AVIS CLIENTS
     ========================================================= */
  const nombre1 = n => n.toLocaleString(L.locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  const stars = n => `<span class="stars" aria-label="${L.starsAria(n)}">${'★'.repeat(n)}<span class="stars__off">${'★'.repeat(5 - n)}</span></span>`;
  const exactStars = n => `<span class="stars stars--exact" aria-label="${L.starsAria(nombre1(n))}"><span class="stars__off">★★★★★</span><span class="stars__on" style="width:${(n / 5) * 100}%">★★★★★</span></span>`;

  // Étoiles + nombre d'avis (en haut de page et dans le configurateur)
  function renderRatings() {
    const note = CONFIG.noteMoyenne;
    const nb = CONFIG.nombreAvis;
    const html = `${exactStars(note)}<strong>${nombre1(note)}/5</strong><span class="rating__count">${L.ratingCount(nb.toLocaleString(L.locale))}</span>`;
    $$('[data-rating]').forEach(el => { el.innerHTML = html; });
    // Version courte (menu mobile) : « ★ 4,7/5 · 548 avis »
    $$('[data-rating-short]').forEach(el => { el.textContent = L.ratingShort(nombre1(note), nb.toLocaleString(L.locale)); });
  }
  renderRatings();

  /* Grille d'avis : avis avec photos en premier, puis les plus récents.
     Répartis en colonnes (de gauche à droite, ligne par ligne) ; « Voir plus d'avis » en ajoute. */
  const rvGrid = $('#reviewsGrid');
  const rvMore = $('#rvMore');
  const RV_PAGE = () => (window.innerWidth < 640 ? 6 : 9);
  const rvCols = () => (window.innerWidth < 640 ? 2 : window.innerWidth < 1000 ? 2 : 3);
  const rvDate = d => new Date(`${d}T12:00:00`).toLocaleDateString(localeDates(), { day: 'numeric', month: 'long', year: 'numeric' });
  let rvData = null;
  let rvShown = 0;

  // Photos d'avis hébergées sur Cloudinary : version allégée au bon format (les originaux pèsent plusieurs Mo).
  // Les adresses signées (avis déposés sur le site) restent telles quelles.
  const cld = (u, w) => u.replace(/^(https:\/\/res\.cloudinary\.com\/[^/]+\/image\/upload\/)(?=v\d+\/)/, `$1f_auto,q_auto,c_limit,w_${w}/`);

  function reviewHTML(a) {
    const long = a.t.length > 230;
    const grand = a.p.map(u => cld(u, 1080));
    const photo = a.p[0]
      ? `<button type="button" class="rv__photo" data-zoom="${esc(grand[0])}" data-zoom-set="${esc(grand.join(' '))}"
           aria-label="${esc(L.rvPhotosAria(a.p.length, a.n))}">
           <img src="${esc(cld(a.p[0], 600))}" alt="${esc(L.rvPhotoAlt(a.n))}" loading="lazy" data-broken="rv">
           ${a.p.length > 1 ? `<span class="rv__more">+${a.p.length - 1}</span>` : ''}
         </button>`
      : '';
    return `
      <article class="rv">
        ${photo}
        <div class="rv__body">
          <div class="rv__top">${stars(a.r)}<time datetime="${a.d}">${rvDate(a.d)}</time></div>
          ${a.ti ? `<p class="rv__title">${esc(a.ti)}</p>` : ''}
          ${a.t ? `<p class="rv__text${long ? ' is-clamped' : ''}">${esc(a.t)}</p>` : ''}
          ${long ? `<button type="button" class="rv__read" data-rv-read>${L.readMore}</button>` : ''}
          ${a.tr ? `<p class="rv__tr">${L.translated}</p>` : ''}
          <p class="rv__who"><span class="rv__av" aria-hidden="true">${esc(a.n.charAt(0).toUpperCase())}</span>
            <strong>${esc(a.n)}</strong>${a.v ? `<span class="rv__ok">${ICON('i-check')} ${L.verified}</span>` : ''}</p>
        </div>
      </article>`;
  }

  // (Re)construit les colonnes avec les avis déjà affichés
  function layoutReviews() {
    const n = rvCols();
    const cols = Array.from({ length: n }, () => []);
    rvData.avis.slice(0, rvShown).forEach((a, i) => cols[i % n].push(reviewHTML(a)));
    rvGrid.style.setProperty('--rv-cols', n);
    rvGrid.innerHTML = cols.map(c => `<div class="rv-col">${c.join('')}</div>`).join('');
    const left = rvData.avis.length - rvShown;
    rvMore.hidden = left <= 0;
  }

  function renderReviewSummary() {
    const { moyenne, total, repartition } = rvData;
    $('#rvAvg').textContent = nombre1(moyenne);
    $('#rvStars').innerHTML = exactStars(moyenne);
    $('#rvCount').textContent = L.basedOn(total.toLocaleString(L.locale));
    $('#rvBars').innerHTML = repartition.map((nb, i) => `
      <li><span>${5 - i} ★</span><span class="rv-bar"><i style="width:${(nb / total) * 100}%"></i></span><span>${nb.toLocaleString(L.locale)}</span></li>`).join('');
    $('#rvSummary').hidden = false;
  }

  // Affiche les avis du fichier, plus ceux déposés sur le site (« recents »)
  let rvPresse = false;   // le visiteur a cliqué sur un lien vers les avis : leurs photos se chargent tout de suite
  function afficherAvis(base, recents) {
    // Les avis déposés sur le site s'ajoutent à la note globale et s'affichent en premier (les plus récents)
    const repartition = base.repartition.slice();
    recents.forEach(a => { repartition[5 - a.r] += 1; });
    const total = base.total + recents.length;
    const moyenne = total ? (base.moyenne * base.total + recents.reduce((s, a) => s + a.r, 0)) / total : base.moyenne;
    // Toutes les notes comptent dans le total ; la grille montre les avis avec un texte ou une photo
    rvData = { moyenne, total, repartition, avis: [...recents, ...base.avis.filter(a => a.t || a.p.length)] };
    // Les notes affichées partout reprennent exactement le fichier d'avis
    CONFIG.noteMoyenne = moyenne;
    CONFIG.nombreAvis = total;
    renderRatings();
    renderReviewSummary();
    rvShown = Math.max(rvShown, RV_PAGE());
    layoutReviews();
    if (rvPresse) $$('img[loading="lazy"]', rvGrid).forEach(img => { img.loading = 'eager'; });
  }

  function loadReviews() {
    if (rvData) return;
    rvData = { avis: [] };
    // Avis déposés sur le site (vérifiés et modérés) : récupérés à part, sans bloquer les autres en cas d'erreur
    const nouveaux = Promise.resolve({ avis: [] }).then(d => d.avis || []).catch(() => []);
    fetch(window.KZ.avis).then(r => r.json())
      .then(base => {
        // On n'attend pas les avis du site plus de 0,6 s : s'ils arrivent après, ils sont ajoutés en tête
        const attente = new Promise(r => setTimeout(() => r(null), 600));
        Promise.race([nouveaux, attente]).then(recents => {
          afficherAvis(base, recents || []);
          if (!recents) nouveaux.then(r => { if (r.length) afficherAvis(base, r); });
        });
      })
      .catch(() => { rvGrid.innerHTML = ''; });
  }

  rvMore.addEventListener('click', () => { rvShown += RV_PAGE(); layoutReviews(); });

  /* ---------- Laisser un avis (clients vérifiés, publié après relecture) ----------
     1. le serveur vérifie l'achat (e-mail + numéro de commande) et autorise l'envoi des photos ;
     2. les photos partent directement dans le dossier privé Cloudinary ;
     3. l'avis est déposé, en attente de modération dans l'Atelier. */
  const avisDialog = $('#avisDialog');
  const avisForm = $('#avisForm');
  const avisPhotosBox = $('#avisPhotos');
  let avisPhotos = [];
  const AV_MAX_PHOTOS = 3;

  function renderAvisPhotos() {
    avisPhotosBox.innerHTML = avisPhotos.map((p, i) => `
      <span class="av-photo"><img src="${p.url}" alt="${esc(L.photoN(i + 1))}">
        <button type="button" data-av-del="${i}" aria-label="${esc(L.removePhoto)}">${ICON('i-x')}</button></span>`).join('') +
      (avisPhotos.length < AV_MAX_PHOTOS ? `
      <label class="av-add"><input type="file" accept="image/*,.heic,.heif" multiple hidden data-av-file>${ICON('i-camera')}<span>${L.upAdd}</span></label>` : '');
  }
  function avisErreur(champ, msg) { const el = $(`[data-av-err="${champ}"]`, avisForm); if (el) el.textContent = msg || ''; }
  function openAvis(ref) {
    avisForm.reset();
    avisPhotos.forEach(p => URL.revokeObjectURL(p.url));
    avisPhotos = [];
    renderAvisPhotos();
    ['note', 'texte'].forEach(c => avisErreur(c, ''));
    $('#avisError').textContent = '';
    avisForm.hidden = false;
    $('#avisDone').hidden = true;
    if (ref) avisForm.elements.ref.value = ref;
    openDialog(avisDialog);
  }
  document.addEventListener('click', e => { if (e.target.closest('[data-open-avis]')) openAvis(); });
  avisDialog.addEventListener('click', e => { if (e.target === avisDialog || e.target.closest('[data-close-modal]')) avisDialog.close(); });
  avisPhotosBox.addEventListener('change', e => {
    if (!e.target.matches('[data-av-file]')) return;
    for (const f of e.target.files) {
      if (avisPhotos.length >= AV_MAX_PHOTOS) break;
      if (!(f.type.startsWith('image/') || /\.(heic|heif)$/i.test(f.name)) || f.size > 15 * 1024 * 1024) { toast(L.avPhotoErr); continue; }
      avisPhotos.push({ file: f, url: URL.createObjectURL(f) });
    }
    renderAvisPhotos();
  });
  avisPhotosBox.addEventListener('click', e => {
    const del = e.target.closest('[data-av-del]');
    if (!del) return;
    const [p] = avisPhotos.splice(+del.dataset.avDel, 1);
    if (p) URL.revokeObjectURL(p.url);
    renderAvisPhotos();
  });
  avisForm.addEventListener('change', e => { if (e.target.name === 'note') avisErreur('note', ''); });

  const postJSON = (url, body) => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Langue': L.lang }, body: JSON.stringify(body) })
    .then(async r => { const d = await r.json().catch(() => ({})); if (!r.ok) throw new Error(r.status === 429 ? L.tooMany : (d.error || L.genericErr)); return d; });

  avisForm.addEventListener('submit', async e => {
    e.preventDefault();
    const f = avisForm.elements, btn = $('#avisSubmit'), err = $('#avisError');
    err.textContent = '';
    const note = Number((avisForm.querySelector('input[name="note"]:checked') || {}).value);
    const texte = f.texte.value.trim();
    let ok = true;
    if (!note) { avisErreur('note', L.avNote); ok = false; }
    if (texte.length < 10) { avisErreur('texte', L.avText); ok = false; } else avisErreur('texte', '');
    if (!f.email.value.trim() || !f.ref.value.trim()) { err.textContent = L.avVerif; ok = false; }
    if (!ok) return;

    btn.classList.add('is-busy'); btn.disabled = true;
    try {
      // Boutique Nos Petites Pattes : photos sur Cloudinary, puis avis envoyé à Kizuna Paws (vérifié avant publication)
      const liens = [];
      for (const p of avisPhotos) {
        const fd = new FormData();
        fd.append('file', p.file);
        fd.append('upload_preset', 'npp-uploads');
        const up = await fetch('https://api.cloudinary.com/v1_1/dvtyqvo5c/image/upload', { method: 'POST', body: fd });
        const img = await up.json().catch(() => ({}));
        if (!up.ok || !img.secure_url) throw new Error(L.avUpload);
        liens.push(img.secure_url);
      }
      const rep = await fetch('https://kizunapaws.com/api/boutique/avis-npp', { method: 'POST', headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({ note, texte, email: f.email.value.trim(), commande: f.ref.value.trim(), photos: liens, site: f.site.value }) });
      const d = await rep.json().catch(() => ({}));
      if (!rep.ok) throw new Error(rep.status === 429 ? L.tooMany : (d.error || L.genericErr));
      $('#avisDoneName').textContent = '';
      avisForm.hidden = true;
      $('#avisDone').hidden = false;
    } catch (ex) {
      err.textContent = ex.message || L.netError;
    } finally {
      btn.classList.remove('is-busy'); btn.disabled = false;
    }
  });

  // Lien direct depuis un e-mail : kizunapaws.com/?avis=KP-AB12CD34 ouvre le formulaire, numéro déjà rempli
  (function avisDepuisLien() {
    const q = new URLSearchParams(location.search);
    if (!q.has('avis')) return;
    const ref = (q.get('avis') || '').toUpperCase();
    history.replaceState(null, '', location.pathname + location.hash);
    $('#avis').scrollIntoView();
    openAvis(/^KP-[A-Z0-9]{8}$/.test(ref) ? ref : '');
  })();
  rvGrid.addEventListener('click', e => {
    const read = e.target.closest('[data-rv-read]');
    if (!read) return;
    const text = read.previousElementSibling;
    const open = text.classList.toggle('is-clamped');
    read.textContent = open ? L.readMore : L.readLess;
  });
  let rvCount = rvCols();
  window.addEventListener('resize', () => {
    if (!rvData || !rvData.avis.length || rvCols() === rvCount) return;
    rvCount = rvCols();
    layoutReviews();
  });
  // Chargement des avis (fichier léger, photos chargées seulement à l'approche) :
  // - dès que la page a fini de charger, pour qu'ils soient prêts quand on y arrive ;
  // - tout de suite si l'on clique sur un lien « Avis » (avec leurs photos), ou si l'on y descend avant.
  document.addEventListener('click', e => {
    if (!e.target.closest('a[href="#avis"]')) return;
    rvPresse = true;
    loadReviews();
    $$('img[loading="lazy"]', rvGrid).forEach(img => { img.loading = 'eager'; });
  });
  const rvTot = () => ('requestIdleCallback' in window ? requestIdleCallback(loadReviews, { timeout: 2500 }) : setTimeout(loadReviews, 1200));
  if (document.readyState === 'complete') rvTot(); else window.addEventListener('load', rvTot, { once: true });
  if ('IntersectionObserver' in window) {
    const rvIo = new IntersectionObserver(entries => {
      if (entries.some(en => en.isIntersecting)) { loadReviews(); rvIo.disconnect(); }
    }, { rootMargin: '900px 0px' });
    rvIo.observe($('#avis'));
  } else {
    loadReviews();
  }

  /* =========================================================
     AMBIANCE : annonces, hero, pétales, révélations, vidéos
     ========================================================= */
  // Méga offre : seul message du bandeau du haut tant qu'elle dure ; après le 30 novembre, ses blocs disparaissent
  // ([data-offre], style.css) et le bandeau reprend ses autres messages
  if (!offreActive()) document.documentElement.classList.add('offre-finie');
  const mega = $('#announce .annonce-mega');
  const annItems = mega && offreActive() ? [mega] : $$('#announce p').filter(p => !p.matches('[data-offre]'));
  if (annItems.length && !annItems.some(p => p.classList.contains('is-active'))) {
    $$('#announce p').forEach(p => p.classList.remove('is-active'));
    annItems[0].classList.add('is-active');
  }
  // Compte à rebours de la méga offre : [data-compte] (jours, heures, minutes, secondes) et [data-compte="court"] (une ligne)
  const comptes = $$('[data-compte]');
  function majComptes() {
    const reste = FIN_OFFRE - Date.now();
    if (reste <= 0) { document.documentElement.classList.add('offre-finie'); return false; }
    const deux = n => String(n).padStart(2, '0');
    const j = Math.floor(reste / 864e5), h = deux(Math.floor(reste / 36e5) % 24), m = deux(Math.floor(reste / 6e4) % 60), s = deux(Math.floor(reste / 1e3) % 60);
    comptes.forEach(el => {
      if (el.dataset.compte === 'court') { el.textContent = L.compteCourt(j, h, m, s); return; }
      if (!el.querySelector('b')) el.innerHTML = [L.compte.j, L.compte.h, L.compte.m, L.compte.s].map(u => `<span><b></b><small>${u}</small></span>`).join('');
      el.querySelectorAll('b').forEach((b, i) => {
        const v = String([j, h, m, s][i]);
        if (b.textContent === v) return;
        b.textContent = v;
        b.classList.remove('tic');
        void b.offsetWidth;
        b.classList.add('tic');
      });
    });
    return true;
  }
  if (comptes.length && majComptes()) setInterval(majComptes, 1000);
  let annIndex = 0;
  if (annItems.length > 1) setInterval(() => {
    annItems[annIndex].classList.remove('is-active');
    annIndex = (annIndex + 1) % annItems.length;
    annItems[annIndex].classList.add('is-active');
  }, 4000);

  const heroImgs = $$('#heroStack img');
  let heroIndex = 0;
  if (!reduceMotion && heroImgs.length > 1) setInterval(() => {
    heroImgs[heroIndex].classList.remove('is-active');
    heroIndex = (heroIndex + 1) % heroImgs.length;
    heroImgs[heroIndex].classList.add('is-active');
  }, 3800);

  const PETALS = ['https://kizunapaws.com/assets/img/petale-1.png', 'https://kizunapaws.com/assets/img/petale-2.png', 'https://kizunapaws.com/assets/img/petale-3.png'];
  function makePetals(container, n) {
    if (!container || reduceMotion) return;
    const setFall = () => container.style.setProperty('--fall', `${container.offsetHeight + 90}px`);
    setFall();
    window.addEventListener('resize', setFall);
    for (let k = 0; k < n; k++) {
      const el = document.createElement('span');
      el.className = 'petal';
      const d = 13 + Math.random() * 10;
      el.style.cssText = [
        `left:${(Math.random() * 104 - 2).toFixed(1)}%`,
        `--s:${(12 + Math.random() * 16).toFixed(0)}px`,
        `--d:${d.toFixed(1)}s`,
        `--f:${(2.4 + Math.random() * 2.2).toFixed(1)}s`,
        `--delay:${(-Math.random() * d).toFixed(1)}s`,
        `--dx:${(Math.random() * 220 - 70).toFixed(0)}px`,
        `--r0:${(Math.random() * 360).toFixed(0)}deg`,
        `--o:${(0.55 + Math.random() * 0.4).toFixed(2)}`
      ].join(';');
      el.innerHTML = `<img src="${PETALS[k % PETALS.length]}" alt="" width="100" height="100">`;
      container.appendChild(el);
    }
  }
  makePetals($('#leaves'), 22);
  makePetals($('#leaves2'), 14);

  const header = $('#header');
  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  if ('IntersectionObserver' in window && !reduceMotion) {
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    // Carrousels horizontaux : toutes les cartes apparaissent ensemble dès que le carrousel est à l'écran
    // (sinon la carte suivante, à peine visible sur le côté, resterait invisible jusqu'au défilement)
    const carIo = new IntersectionObserver(entries => entries.forEach(en => {
      if (!en.isIntersecting) return;
      $$('.reveal', en.target).forEach(el => el.classList.add('is-in'));
      carIo.unobserve(en.target);
    }), { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('.reveal').forEach(el => {
      const sibs = [...el.parentElement.children].filter(x => x.classList.contains('reveal'));
      el.style.transitionDelay = `${Math.min(sibs.indexOf(el), 5) * 70}ms`;
      if (el.parentElement.matches('.carousel')) carIo.observe(el.parentElement);
      else io.observe(el);
    });
  } else {
    $$('.reveal').forEach(el => el.classList.add('is-in'));
  }

  // Photos des carrousels : toutes chargées dès que le carrousel approche, pas une à une pendant le défilement
  if ('IntersectionObserver' in window) {
    const carImgIo = new IntersectionObserver(entries => entries.forEach(en => {
      if (!en.isIntersecting) return;
      $$('img[loading="lazy"]', en.target).forEach(img => { img.loading = 'eager'; });
      carImgIo.unobserve(en.target);
    }), { rootMargin: '800px 0px' });
    $$('.carousel').forEach(c => carImgIo.observe(c));
  }

  $$('[data-carousel-prev], [data-carousel-next]').forEach(btn => btn.addEventListener('click', () => {
    const id = btn.dataset.carouselPrev || btn.dataset.carouselNext;
    const el = document.getElementById(id);
    const dir = btn.dataset.carouselNext ? 1 : -1;
    el.scrollBy({ left: dir * el.clientWidth * 0.75, behavior: smooth() });
  }));

  // Points de progression sous un carrousel (téléphone) : un point par carte, le point actif suit le défilement
  $$('[data-dots]').forEach(box => {
    const track = document.getElementById(box.dataset.dots);
    if (!track) return;
    const cartes = [...track.children];
    box.innerHTML = cartes.map(() => '<button type="button" tabindex="-1"></button>').join('');
    const points = [...box.children];
    const decalage = c => c.getBoundingClientRect().left - track.getBoundingClientRect().left;
    const maj = () => {
      let actif = 0, meilleur = Infinity;
      cartes.forEach((c, i) => { const d = Math.abs(decalage(c) - (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0)); if (d < meilleur) { meilleur = d; actif = i; } });
      points.forEach((p, i) => p.classList.toggle('is-active', i === actif));
    };
    points.forEach((p, i) => p.addEventListener('click', () => track.scrollBy({ left: decalage(cartes[i]) - (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0), behavior: smooth() })));
    let attente = false;
    track.addEventListener('scroll', () => { if (!attente) { attente = true; requestAnimationFrame(() => { attente = false; maj(); }); } }, { passive: true });
    maj();
  });

  if ('IntersectionObserver' in window) {
    const vio = new IntersectionObserver(entries => entries.forEach(en => {
      const v = $('video', en.target);
      if (en.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
    }), { threshold: 0.45 });
    $$('.v-card').forEach(c => vio.observe(c));
  }

  // Barre d'achat mobile : visible après le haut de page, cachée pendant la personnalisation
  const sticky = $('#stickyCta');
  let rafPending = false;
  function checkSticky() {
    rafPending = false;
    const r = form.getBoundingClientRect();
    const inForm = r.top < window.innerHeight - 120 && r.bottom > 160;
    const heroCta = $('#heroCta');
    const heroPassed = !heroCta.offsetParent || heroCta.getBoundingClientRect().bottom < 0; // page produit : pas de haut de page
    sticky.classList.toggle('is-visible', heroPassed && !inForm);
    // Utilisé par la bulle de discussion sur mobile (au-dessus de la barre, cachée pendant la personnalisation)
    document.body.classList.toggle('has-sticky', heroPassed && !inForm);
    // Bulle de discussion : sur la page produit, le formulaire commence tout en haut (offres, photos) ; elle reste
    // visible dès l'arrivée et ne se cache que pendant la saisie (des cartes t-shirt au bouton « Ajouter au panier »)
    let enSaisie = inForm;
    if (true) {
      const debut = teesEl.getBoundingClientRect().top, fin = $('#addToCart').getBoundingClientRect().bottom;
      enSaisie = debut < window.innerHeight - 120 && fin > 160;
    }
    document.body.classList.toggle('in-form', enSaisie);
  }
  window.addEventListener('scroll', () => {
    if (!rafPending) { rafPending = true; requestAnimationFrame(checkSticky); }
  }, { passive: true });
  window.addEventListener('resize', checkSticky);

  /* =========================================================
     BULLE DE DISCUSSION : réponses immédiates aux questions fréquentes
     Réponses reprises de la FAQ du site ; prix, remises et dates calculés
     à partir de CONFIG pour rester toujours à jour.
     ========================================================= */
  const chat = $('#chat');
  const chatFab = $('#chatFab');
  const chatLog = $('#chatLog');
  const chatChips = $('#chatChips');
  const chatInput = $('#chatInput');
  const SEAL = '<span class="chat-msg__av" aria-hidden="true">絆</span>';
  const CONTACT = 'contact@kizunapaws.com';

  // Texte sans accents, majuscules ni ponctuation, pour reconnaître les mots-clés
  // (les mots courts sont écrits entre espaces dans les listes : « nom » ne doit pas trouver « nombre »)
  const norm = s => s.toLowerCase().replace(/ß/g, 'ss').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9€$£]+/g, ' ');

  // Normalisation complète d'une phrase : « T-shirt », « tee shirt », « tshirts » → « tshirt »
  const normText = s => ` ${norm(s).replace(/\btee ?shirts?\b/g, 'tshirt').replace(/\bt ?shirts?\b/g, 'tshirt').replace(/\s+/g, ' ').trim()} `;

  const priceFor = q => money(G.prixBase * q - remise(q));
  const btn = (label, attrs, icon) => `<button type="button" class="chat__act" ${attrs}>${icon ? ICON(icon) : ''}${label}</button>`;
  const MAILTO = `<a href="mailto:${CONTACT}">${CONTACT}</a>`;

  // Sujets et réponses dans la langue de la page (assets/js/i18n/<langue>.js) ; prix, dates et note toujours à jour
  const TOPICS = L.topics({
    maxPhotos: MAX_PHOTOS, maxName: MAX_NAME, mailto: MAILTO, days: CONFIG.joursLivraison, offre: offreActive,
    priceFor, regular: () => money(G.prixBase), discount: n => euros(remise(n)), extra: n => euros(G.supplements[n]),
    eta: () => esc($('#etaShip').textContent),
    rating: () => CONFIG.noteMoyenne.toLocaleString(L.locale, { maximumFractionDigits: 2 }), reviewCount: () => CONFIG.nombreAvis.toLocaleString(L.locale),
    colorList: () => COLORS.filter(c => c.hex && !c.retire).map(c => c.label.toLowerCase()).join(', '),
    btnCreate: label => btn(label, 'data-chat-act="creer"', 'i-arrow'),
    btnSize: label => btn(label, 'data-open-size', 'i-ruler'),
    btnTips: label => btn(label, 'data-open-tips', 'i-camera'),
    btnReviews: label => btn(label, 'data-chat-act="avis"', 'i-arrow'),
    btnMail: label => `<a class="chat__act" href="mailto:${CONTACT}">${ICON('i-mail')}${label}</a>`
  });

  // Distance d'édition (fautes de frappe : une lettre en trop, en moins ou remplacée)
  function editDistance(a, b) {
    const row = Array.from({ length: b.length + 1 }, (_, j) => j);
    for (let i = 1; i <= a.length; i++) {
      let prev = row[0];
      row[0] = i;
      for (let j = 1; j <= b.length; j++) {
        const cur = row[j];
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
        prev = cur;
      }
    }
    return row[b.length];
  }

  // Score d'un mot-clé dans la phrase :
  // expression (plusieurs mots) = présente telle quelle ; mot court (≤ 3 lettres) = mot exact ;
  // mot plus long = début d'un mot (« livr » → livraison) ou à une faute de frappe près.
  function keyScore(key, text, words) {
    if (['€', '$', '£'].includes(key)) return text.includes(key) ? 3 : 0; // symbole de monnaie
    if (key.endsWith('$')) return text.includes(` ${key.slice(0, -1)} `) ? key.length + 2 : 0; // expression, mot final exact
    if (key.includes(' ')) return text.includes(` ${key}`) ? key.length + 3 : 0;
    if (key.length <= 3) return words.includes(key) ? key.length : 0;
    if (words.some(w => w.startsWith(key))) return key.length;
    // Fautes de frappe : seulement sur les mots assez longs (sinon « chat » passerait pour « achat »)
    if (key.length >= 6 && words.some(w => Math.abs(w.length - key.length) <= 1 && editDistance(w, key) <= 1)) return key.length - 1;
    if (key.length >= 7 && words.some(w => w.length >= key.length && [-1, 0, 1].some(d => editDistance(w.slice(0, key.length + d), key) <= 1))) return key.length - 1;
    return 0;
  }

  // Classe les sujets du plus au moins pertinent. Une vraie question passe avant les politesses
  // (« Bonjour, quel est le prix ? » → le prix).
  function chatRank(text) {
    const t = normText(text);
    const words = t.trim().split(' ');
    const ranked = TOPICS
      .map((topic, i) => ({ topic, i, score: topic.keys.reduce((s, k) => s + keyScore(k, t, words), 0) }))
      .filter(r => r.score > 0)
      .sort((a, b) => b.score - a.score || a.i - b.i);
    const real = ranked.filter(r => !r.topic.social);
    return real.length ? real : ranked;
  }
  const chatMatch = text => (chatRank(text)[0] || {}).topic || null;

  function chatScroll() { chatLog.scrollTop = chatLog.scrollHeight; }

  // Typographie française : espace insécable avant ? ! : ; » et après « (pas de « ? » seul en début de ligne)
  const nbsp = s => (L.typoFr ? s.replace(/ ([?!:;»])/g, '\u00a0$1').replace(/« /g, '«\u00a0') : s);

  function chatSay(html, acts) {
    const msg = document.createElement('div');
    msg.className = 'chat-msg';
    msg.innerHTML = `${SEAL}<div class="chat-msg__b">${nbsp(html)}${acts ? `<div class="chat-msg__acts">${acts}</div>` : ''}</div>`;
    chatLog.append(msg);
    chatScroll();
  }

  // Petit délai « … » (en train d'écrire) avant chaque réponse
  let chatBusy = Promise.resolve();
  function chatReply(html, acts) {
    chatBusy = chatBusy.then(() => new Promise(resolve => {
      const typing = document.createElement('div');
      typing.className = 'chat-msg';
      typing.innerHTML = `${SEAL}<div class="chat-msg__b chat-typing" aria-label="${esc(L.chatTyping)}"><i></i><i></i><i></i></div>`;
      chatLog.append(typing);
      chatScroll();
      const delay = reduceMotion ? 0 : Math.min(1100, 450 + html.length * 1.2);
      setTimeout(() => { typing.remove(); chatSay(html, acts); resolve(); }, delay);
    }));
  }

  function chatUser(text) {
    const msg = document.createElement('div');
    msg.className = 'chat-msg chat-msg--me';
    msg.innerHTML = `<div class="chat-msg__b">${esc(text)}</div>`;
    chatLog.append(msg);
    chatScroll();
  }

  // Question notée anonymement pour l'Atelier (voir netlify/lib/questions.mjs) ; respecte le refus de la mesure d'audience
  function noterQuestion(q, topic, bouton) {
    return;
    if (mesureRefusee()) return;
    const corps = JSON.stringify({ q: String(q).slice(0, 300), s: topic ? topic.id : '', b: bouton ? 1 : 0, l: L.lang });
    try { if (navigator.sendBeacon && navigator.sendBeacon('/api/boutique/chat', new Blob([corps], { type: 'application/json' }))) return; } catch (e) { /* repli ci-dessous */ }
    fetch('/api/boutique/chat', { method: 'POST', body: corps, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
  }

  function chatAnswer(topic) {
    if (topic) { chatReply(topic.answer(), topic.acts && topic.acts()); return; }
    // Pas compris : on propose les questions les plus courantes plutôt qu'une impasse
    const suggest = L.chatSuggest
      .map(id => TOPICS.find(t => t.id === id))
      .map(t => `<button type="button" class="chat__chip" data-chat-topic="${t.id}">${nbsp(esc(t.chip))}</button>`).join('');
    chatReply(L.chatNotUnderstood,
      `${suggest}<p class="chat-msg__more">${L.chatOrWrite(MAILTO)}</p>`);
  }

  function renderChatChips() {
    chatChips.innerHTML = TOPICS.filter(t => t.chip)
      .map(t => `<button type="button" class="chat__chip" data-chat-topic="${t.id}">${nbsp(esc(t.chip))}</button>`).join('');
  }

  let chatStarted = false;
  function openChat() {
    chat.hidden = false;
    chatFab.setAttribute('aria-expanded', 'true');
    chatFab.classList.remove('is-hinting');
    document.body.classList.add('chat-open');
    if (!chatStarted) {
      chatStarted = true;
      renderChatChips();
      chatReply(L.chatHello);
    }
    if (!isTouch) setTimeout(() => chatInput.focus(), 60); // sur téléphone, on n'ouvre pas le clavier d'office
  }
  function closeChat() {
    chat.hidden = true;
    chatFab.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('chat-open');
    chatFab.focus({ preventScroll: true });
  }

  chatFab.addEventListener('click', () => (chat.hidden ? openChat() : closeChat()));
  chat.addEventListener('click', e => {
    if (e.target.closest('[data-chat-close]')) { closeChat(); return; }
    const chip = e.target.closest('[data-chat-topic]');
    if (chip) {
      const topic = TOPICS.find(t => t.id === chip.dataset.chatTopic);
      chatUser(nbsp(topic.chip));
      noterQuestion(topic.chip, topic, true);
      chatAnswer(topic);
      return;
    }
    // Boutons « Créer mon t-shirt » / « Voir les avis » : on ferme et on descend à la bonne section
    const go = e.target.closest('[data-chat-act]');
    if (go) {
      closeChat();
      // Pages de la boutique : le formulaire et les avis sont sur la page du t-shirt personnalisé
      if (PAGE_BOUTIQUE) { location.href = `${RACINE}t-shirt-samourai#${go.dataset.chatAct === 'avis' ? 'avis' : 'creer'}`; return; }
      $(go.dataset.chatAct === 'avis' ? '#avis' : '#creer').scrollIntoView({ behavior: smooth(), block: 'start' });
    }
  });
  $('#chatForm').addEventListener('submit', e => {
    e.preventDefault();
    const text = chatInput.value.trim();
    if (!text) return;
    chatInput.value = '';
    chatUser(text);
    const sujet = chatMatch(text);
    noterQuestion(text, sujet, false);
    chatAnswer(sujet);
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && !chat.hidden && !document.querySelector('dialog[open]')) closeChat();
  });

  // Bulle « Une question ? » montrée une fois, quelques secondes : sur téléphone peu après l'arrivée (pour comprendre
  // tout de suite à quoi sert la bulle), sur ordinateur après un moment sur le site
  const surTelephone = window.matchMedia('(max-width: 960px)').matches;
  setTimeout(() => {
    if (!chat.hidden) return;
    chatFab.classList.add('is-hinting');
    setTimeout(() => chatFab.classList.remove('is-hinting'), surTelephone ? 7000 : 6000);
  }, surTelephone ? 2500 : 12000);

  /* =========================================================
     LANGUE ET PAYS : détection du pays (devise) et sélecteur
     ========================================================= */
  const LANGUES = { fr: 'Français', en: 'English', de: 'Deutsch', it: 'Italiano', es: 'Español' };
  // Langue retenue : un visiteur arrivé sur une page en anglais, allemand, italien ou espagnol (une pub en italien, par
  // exemple) retrouve cette langue en revenant plus tard sur kizunapaws.com, même si son téléphone est réglé dans une
  // autre langue (cookie lu par Netlify, comme celui du sélecteur). Un choix déjà fait n'est jamais écrasé ; la France
  // reste toujours en français (règle par pays de _redirects)
  if (L.lang !== 'fr' && !/(?:^|;\s*)nf_lang=/.test(document.cookie)) {
    document.cookie = `nf_lang=${L.lang}; path=/; max-age=31536000; samesite=lax`;
  }
  const symbole =() => (new Intl.NumberFormat(localeMonnaie(), { style: 'currency', currency: DEVISE }).formatToParts(0).find(p => p.type === 'currency') || {}).value || DEVISE;
  const paysAffiche = () => (PAYS_LIVRES.includes(PAYS) ? PAYS : PAYS_PAR_LANGUE[L.lang]);

  // Pays non livré (Royaume-Uni suspendu, Japon…) : la langue et la devise seulement, sans nom de pays trompeur
  function majSelecteur() {
    const texte = PAYS_LIVRES.includes(PAYS) ? `${LANGUES[L.lang]} · ${L.countryCurrency(nomPays(PAYS), symbole())}` : `${LANGUES[L.lang]} · ${symbole()}`;
    $$('[data-locale-label]').forEach(el => { el.textContent = texte; });
  }

  // Nouveau pays : nouvelle devise, tous les prix (panier compris) sont recalculés
  function appliquerPays(p) {
    const avant = DEVISE;
    PAYS = p || 'XX';
    DEVISE = DEVISE_DU_PAYS[PAYS] || 'EUR';
    G = GRILLES[DEVISE];
    document.documentElement.classList.remove('devise-attente');
    if (DEVISE !== avant) {
      renderTees();
      renderCart();
      if (!checkout.hidden) renderCheckout();
      if (stripeElements && cart.length) stripeElements.update({ amount: centimes(), currency: DEVISE.toLowerCase() });
    }
    const animer = pricesReady;
    pricesReady = false; // pas d'effet « prix modifié » pour un simple changement de devise
    renderPrices();
    pricesReady = animer;
    renderEta();
    // Pays de livraison proposé : suit le pays du visiteur tant qu'il n'a pas été changé à la main
    if (!coForm.elements.pays.dataset.touche) paysParDefaut();
    majSelecteur();
    if (cookiesPrets) deciderCookies(); // bandeau cookies selon le pays (voir « COOKIES »)
  }
  coForm.elements.pays.addEventListener('change', () => { coForm.elements.pays.dataset.touche = '1'; });

  // Pays détecté par Netlify (/geo.json, d'après l'adresse IP), vérifié à CHAQUE visite (voyage, VPN…).
  // Le pays de la visite précédente (lu par early.js) sert seulement à afficher les prix tout de suite ;
  // s'il a changé, les prix passent dans la nouvelle devise. Sans réponse : pays précédent, sinon région du
  // navigateur (« en-GB » → Royaume-Uni), sinon pays de la langue de la page.
  function detecterPays() {
    const region = (navigator.languages || [navigator.language]).map(l => (l || '').split('-')[1]).find(r => r && /^[A-Za-z]{2}$/.test(r));
    const provisoire = PAYS || (region ? region.toUpperCase() : PAYS_PAR_LANGUE[L.lang]);
    let fait = false;
    const finir = p => {
      if (fait) return;
      fait = true;
      if (p !== PAYS || document.documentElement.classList.contains('devise-attente')) appliquerPays(p);
    };
    Promise.resolve({ ok: true, json: () => ({ pays: 'FR' }) })
      .then(r => (r.ok ? r.json() : {}))
      .then(d => {
        const p = (d && /^[A-Z]{2}$/.test(d.pays || '') && d.pays) || '';
        if (p) ecrireStock('kp-geo', JSON.stringify({ p, t: Date.now() }));
        finir(p || provisoire);
      })
      .catch(() => finir(provisoire));
    setTimeout(() => finir(provisoire), 2500);
  }

  // Sélecteur (pied de page et menu) : langue de la page + pays de livraison (qui fixe la devise)
  const localeDialog = $('#localeDialog');
  const localeForm = $('#localeForm');
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-open-locale]')) return;
    if (!menu.hidden) closeMenu();
    localeForm.elements.langue.value = L.lang;
    const sel = localeForm.elements.pays;
    if (!sel.options.length) {
      sel.innerHTML = PAYS_LIVRES.map(c => [c, nomPays(c)]).sort((a, b) => a[1].localeCompare(b[1], L.lang))
        .map(([c, n]) => `<option value="${c}">${esc(n)} · ${esc((new Intl.NumberFormat(L.locale, { style: 'currency', currency: DEVISE_DU_PAYS[c] || 'EUR' }).formatToParts(0).find(x => x.type === 'currency') || {}).value || '')}</option>`).join('');
    }
    sel.value = paysAffiche();
    openDialog(localeDialog);
  });
  localeDialog.addEventListener('click', e => { if (e.target === localeDialog || e.target.closest('[data-close-modal]')) localeDialog.close(); });
  localeForm.addEventListener('submit', e => {
    e.preventDefault();
    const langue = localeForm.elements.langue.value;
    const pays = localeForm.elements.pays.value;
    ecrireStock('kp-pays', pays);
    // Cookie lu par Netlify : la page d'accueil ne redirige plus d'après la langue du téléphone
    document.cookie = `nf_lang=${langue}; path=/; max-age=31536000; samesite=lax`;
    if (langue !== L.lang) {
      // Même page dans l'autre langue (/cgv → /en/cgv), en gardant la section en cours
      const page = location.pathname.replace(/^\/(en|de|it|es)(?=\/|$)/, '') || '/';
      location.href = `${langue === 'fr' ? '' : `/${langue}`}${page}${location.hash}`;
      return;
    }
    localeDialog.close();
    appliquerPays(pays);
  });

  /* =========================================================
     COOKIES ET MESURE DES PUBLICITÉS (pixel Meta)
     Le pixel n'est chargé qu'après l'accord du visiteur (règles de la CNIL). Choix gardé 6 mois (« kp-consent ») ;
     « Gérer les cookies » (pied de page) permet de le changer à tout moment. Refuser ne change rien au site.
     Les achats sont aussi envoyés à Meta par le serveur (API Conversions, netlify/lib/meta.mjs), uniquement avec
     cet accord : l'événement « Purchase » porte le même identifiant des deux côtés (n° du paiement Stripe), Meta
     ne le compte donc qu'une fois.
     ========================================================= */
  // Vue du produit : quand la création du t-shirt arrive à l'écran (une fois par visite)
  const zoneCreation = $('#creer');
  if (zoneCreation && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver(entrees => {
      if (!entrees.some(e => e.isIntersecting)) return;
      vuProduit = true;
      mesurer('produit');
      envoyerVueProduit();
      obs.disconnect();
    }, { rootMargin: '0px 0px -30% 0px' }); // la section est haute : dès qu'elle entre dans le haut de l'écran
    obs.observe(zoneCreation);
  }

  // Bandeau : « Refuser » et « Accepter » strictement identiques (règle de la CNIL). Sceau 絆 aux couleurs du site.
  const lienPiedConf = $('.footer a[href$="confidentialite"]');
  const lienConfidentialite = `${lienPiedConf ? lienPiedConf.getAttribute('href') : 'confidentialite'}#cookies`;
  const bandeau = document.createElement('div');
  bandeau.className = 'cookie';
  bandeau.id = 'cookieBanner';
  bandeau.setAttribute('role', 'region');
  bandeau.setAttribute('aria-label', L.cookieTitle);
  bandeau.hidden = true;
  bandeau.innerHTML = `
    <span class="cookie__seal" aria-hidden="true">絆</span>
    <div class="cookie__body">
      <p class="cookie__title">${esc(L.cookieTitle)}</p>
      <p class="cookie__text">${L.cookieText(esc(lienConfidentialite))}</p>
    </div>
    <div class="cookie__actions">
      <button type="button" class="cookie__btn" data-cookie="non">${esc(L.cookieRefuse)}</button>
      <button type="button" class="cookie__btn" data-cookie="oui">${esc(L.cookieAccept)}</button>
    </div>`;
  document.body.appendChild(bandeau);
  bandeau.addEventListener('click', e => {
    const b = e.target.closest('[data-cookie]');
    if (!b) return;
    choisirConsent(b.dataset.cookie);
  });
  function choisirConsent(v) {
    consent = v;
    ecrireStock('kp-consent', JSON.stringify({ v, t: Date.now() }));
    bandeau.hidden = true;
    appliquerMesure();
  }
  // Pixel chargé ou coupé selon l'accord (choix du visiteur, ou pays sans bandeau)
  function appliquerMesure() {
    if (mesureAutorisee()) { chargerPixel(); return; }
    if (pixelCharge && window.fbq) {
      // Retrait de l'accord : plus rien n'est envoyé, et les cookies du pixel sont effacés
      window.fbq('consent', 'revoke');
      ['_fbp', '_fbc'].forEach(n => {
        document.cookie = `${n}=; Max-Age=0; path=/`;
        document.cookie = `${n}=; Max-Age=0; path=/; domain=.${location.hostname.replace(/^www\./, '')}`;
      });
    }
  }
  // Une fois le pays connu (visite précédente, détection, ou choix dans le sélecteur) : bandeau ou mesure d'office
  function deciderCookies() {
    bandeau.hidden = true; return; // bannière cookies de Shopify
    if (!PAYS) return; // détection du pays en cours : appliquerPays() rappellera cette fonction
    if (consent === null) bandeau.hidden = sansBandeau();
    appliquerMesure();
  }
  // « Gérer les cookies », ajouté aux liens du pied de page (à côté de la politique de confidentialité)
  const listeLegale = lienPiedConf ? lienPiedConf.closest('ul') : null;
  if (listeLegale) {
    const li = document.createElement('li');
    li.innerHTML = `<button type="button" class="footer__cookies">${esc(L.cookieManage)}</button>`;
    listeLegale.appendChild(li);
    li.firstChild.addEventListener('click', () => { bandeau.hidden = false; $('[data-cookie="oui"]', bandeau).focus(); });
  }
  cookiesPrets = true;
  if (consent === 'oui') chargerPixel();
  deciderCookies();

  /* =========================================================
     BOUTIQUE : t-shirts tout faits des gammes japonaises
     Page « boutique » : filtres par gamme. Page « modele » : choix de la taille et ajout au panier.
     Les pages sont fabriquées par scripts/build.js (contenu déjà écrit dans la langue de la page).
     ========================================================= */
  if (PAGE === 'boutique') {
    const filtres = $('#bqFiltres');
    const cartes = $$('.bq-carte[data-gamme]');
    const filtrer = g => {
      const gamme = gammeParId(g) ? g : 'tout';
      $$('[data-filtre]', filtres).forEach(b => { const on = b.dataset.filtre === gamme; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
      cartes.forEach(c => { c.hidden = gamme !== 'tout' && c.dataset.gamme !== gamme; });
    };
    filtres.addEventListener('click', e => {
      const b = e.target.closest('[data-filtre]');
      if (!b) return;
      filtrer(b.dataset.filtre);
      history.replaceState(null, '', b.dataset.filtre === 'tout' ? location.pathname : `#${b.dataset.filtre}`);
      mesurer('boutique_filtre');
    });
    // Lien direct vers une gamme (boutique#chibi, depuis une page modèle ou une publicité)
    filtrer(location.hash.slice(1));
    window.addEventListener('hashchange', () => filtrer(location.hash.slice(1)));
  }

  if (PAGE === 'modele') {
    const fiche = $('#mdl');
    const ref = fiche.dataset.ref;
    let taille = null;
    const erreur = $('#mdlErreur');
    fiche.addEventListener('click', e => {
      const b = e.target.closest('[data-taille]');
      if (!b) return;
      taille = b.dataset.taille;
      $$('[data-taille]', fiche).forEach(x => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on); });
      $('.tb__sizes', fiche).classList.remove('has-error');
      erreur.textContent = '';
      mesurer('taille_choisie');
    });
    $('#mdlAjout').addEventListener('click', () => {
      if (!taille) {
        const tailles = $('.tb__sizes', fiche);
        tailles.classList.add('has-error');
        erreur.textContent = L.errSize;
        tailles.scrollIntoView({ behavior: smooth(), block: 'center' });
        return;
      }
      cart.push({ id: Date.now(), type: 'modele', ref, size: taille });
      sauverPanier();
      renderCart();
      openCart();
      mesurer('panier');
      suivre('AddToCart', { ...produitMeta(1, ref), value: G.prixBase, currency: DEVISE });
    });
    // Photos : défilement au doigt, points de progression
    const photos = $('#mdlPhotos');
    const points = $$('[data-mdl-point]');
    if (photos && points.length) {
      photos.addEventListener('scroll', () => {
        const i = Math.round(photos.scrollLeft / Math.max(1, photos.clientWidth));
        points.forEach((p, k) => p.classList.toggle('is-active', k === i));
      }, { passive: true });
      points.forEach((p, k) => p.addEventListener('click', () => photos.scrollTo({ left: k * photos.clientWidth, behavior: smooth() })));
    }
    // Vue du produit (statistiques de l'Atelier, et Meta avec l'accord du visiteur)
    mesurer('produit');
    if (mesureAutorisee()) suivre('ViewContent', { ...produitMeta(1, ref), value: G.prixBase, currency: DEVISE });
  }

  /* ===== Accueil (vitrine) : photos de campagne en fondu, avec le sceau et le nom de la gamme ; pétales ===== */
  if (PAGE === 'accueil') {
    const slides = $$('#vxSlides .vx__slide'), barres = $$('#vxBars button');
    const chip = $('#vxChip'), sceau = $('#vxSceau'), nom = $('#vxNom');
    let iv = 0, minuteur;
    const montrer = k => {
      slides[iv].classList.remove('is-active');
      iv = (k + slides.length) % slides.length;
      const s = slides[iv];
      s.classList.add('is-active');
      barres.forEach((b, j) => { b.classList.toggle('is-fait', j < iv); b.classList.remove('is-on'); });
      void barres[iv].offsetWidth;
      barres[iv].classList.add('is-on');
      chip.href = s.dataset.lien;
      [[sceau, s.dataset.sceau], [nom, s.dataset.nom]].forEach(([el, v]) => { el.textContent = v; el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in'); });
      clearTimeout(minuteur);
      if (!reduceMotion) minuteur = setTimeout(() => montrer(iv + 1), 6000);
    };
    barres.forEach((b, k) => b.addEventListener('click', () => montrer(k)));
    if (slides.length > 1 && !reduceMotion) minuteur = setTimeout(() => montrer(1), 6000);
    $$('.v-petales').forEach(b => makePetals(b, 7));
  }

  /* ===== Démarrage ===== */
  mesurer('visite');
  // Visiteur resté plus de 10 secondes, page à l'écran (le temps passé dans une autre appli ne compte pas)
  let tempsVu = 0, vuDepuis = document.hidden ? 0 : Date.now(), minuteur10s;
  const attendre10s = () => { clearTimeout(minuteur10s); minuteur10s = setTimeout(() => mesurer('reste_10s'), Math.max(0, 10000 - tempsVu)); };
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) { if (vuDepuis) tempsVu += Date.now() - vuDepuis; vuDepuis = 0; clearTimeout(minuteur10s); }
    else { vuDepuis = Date.now(); attendre10s(); }
  });
  if (vuDepuis) attendre10s();
  $('#year').textContent = new Date().getFullYear();
  renderTees();
  setPreviewImage(4);
  updatePreview(false);
  renderEta();
  renderPrices();
  // Lien « Finaliser ma commande » d'un e-mail de relance : le panier et les coordonnées du client sont remis
  const jetonReprise = new URLSearchParams(location.search).get('reprise');
  if (jetonReprise) {
    history.replaceState(null, '', location.pathname + location.hash); // après la mesure de la visite (source « E-mail »)
    reprendreCommande(jetonReprise);
  // Panier laissé lors d'une visite précédente : retrouvé tel quel (sauf s'il vient d'être remis au retour d'un paiement)
  } else if (!cart.length && restaurerPanier()) {
    // « Bon retour ! » seulement en revenant d'ailleurs, pas en passant d'une page du site à l'autre (boutique)
    let depuisLeSite = false;
    try { depuisLeSite = !!document.referrer && new URL(document.referrer).host === location.host; } catch (e) { /* rien */ }
    if (!depuisLeSite) setTimeout(() => toast(`${ICON('i-paw')} ${L.cartRestored}`), 1200);
  }
  renderCart();
  checkSticky();
  pricesReady = true;
  // Pays choisi dans le sélecteur : gardé tel quel. Sinon, détection à chaque visite
  // (prix affichés tout de suite avec le pays de la visite précédente, s'il est connu)
  if (PAYS) majSelecteur();
  if (!lireStock('kp-pays')) detecterPays();
})();
